<template>
   <v-layout align-start>
      <v-flex>
         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :right="true"
            :bottom="true"
            :timeout="4000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
               >
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <!-- PANTALLA DE PROGRESO DE REAPLICACIÓN -->
         <ReaplicacionProgreso
            :visible="mostrandoProgreso"
            :cargando="loadingReaplicacion"
            :animando="animandoResultados"
            :ciclo-origen="selectCiclo"
            :ciclo-destino="cicloActual"
            :lista-reaplicacion="listaReaplicacion"
            @cerrar="closeDialogReaplicacion"
         />

         <!-- DIALOG DE REAPLICACION -->
         <v-dialog
            v-model="dialogReaplicacion"
            persistent
            max-width="450"
         >
            <v-card class="overflow-hidden">

               <!-- ══ ESTADO 1: FORMULARIO ══ -->
               <template v-if="!mostrandoProgreso">
                  <v-card-text class="text--primary mb-0 pb-0" style="margin-top: -20px">
                     <v-container grid-list-md fluid class="mb-0 pb-0">
                        <v-layout wrap>
                           <v-flex xs12 mt-4>
                              <span class="text-h5 font-weight-medium">
                                 Reaplicar solicitudes <br />
                                 <span class="colorPrimary">
                                    Ciclo {{ selectCiclo }}
                                    <v-icon class="mx-2" color="primary">fa-long-arrow-alt-right</v-icon>
                                    {{ cicloActual }}
                                 </span>
                              </span>
                           </v-flex>
                           <v-flex xs12 sm4 class="d-flex align-center">
                              <v-switch v-model="swReaplicarCarnet" label="Individual"></v-switch>
                           </v-flex>
                           <v-flex xs12 sm8 class="d-flex align-center">
                              <v-text-field
                                 v-model="reaplicacionCarnet"
                                 v-mask="'####-AA-###'"
                                 outlined dense label="Carnet" hide-details
                                 :disabled="swReaplicarCarnet == false"
                                 color="primary"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs12 mb-2>
                              <v-btn
                                 :disabled="selectCiclo == cicloActual"
                                 color="primary" block
                                 @click="swReaplicarCarnet ? reaplicarCarnet() : reaplicarCiclo()"
                              >
                                 {{ swReaplicarCarnet ? 'Reaplicar carnet' : 'Reaplicar ciclo' }}
                              </v-btn>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>
                  <v-card-actions style="margin-right: 20px; padding-bottom: 20px">
                     <v-spacer></v-spacer>
                     <v-btn color="primary" text @click.native="closeDialogReaplicacion">Salir</v-btn>
                  </v-card-actions>
               </template>


            </v-card>
         </v-dialog>

         <!-- DIALOG REPORTES -->
         <v-dialog v-model="dialogRepGrupales" persistent max-width="450">
            <v-form>
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md fluid>
                        <v-layout wrap>
                           <v-flex xs12 mt-4>
                              <span class="text-h5 font-weight-medium">
                                 Reportes de solicitudes <br />
                                 <span class="colorPrimary">
                                    Ciclo {{ selectCiclo }}
                                 </span>
                              </span>
                           </v-flex>
                           <v-flex xs12 mt-2>
                              <v-btn
                                 color="green darken-3 white--text"
                                 block
                                 @click="reporteExcelSolicitudes"
                              >
                                 <v-icon left>fa-file-excel</v-icon>
                                 Reporte excel
                              </v-btn>
                           </v-flex>
                           <v-flex xs12 mt-4>
                              <v-expansion-panels>
                                 <v-expansion-panel>
                                    <v-expansion-panel-header>
                                       <div>
                                          <v-icon left>fas fa-sliders-h</v-icon>
                                          Opciones resumen general
                                       </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                       <v-layout wrap>
                                          <v-flex xs12>
                                             <span
                                                class="text-subtitle-1 font-weight-medium"
                                                >Filtrar por</span
                                             >
                                          </v-flex>
                                          <v-flex xs12>
                                             <div class="layout justify-center">
                                                <v-radio-group
                                                   v-model="radioResumenGeneral"
                                                   class="justify-center"
                                                   row
                                                >
                                                   <v-radio
                                                      color="primary"
                                                      label="Sin filtrar"
                                                      value="r-nofiltrar"
                                                   ></v-radio>
                                                   <v-radio
                                                      color="primary"
                                                      label="Carrera"
                                                      value="r-carrera"
                                                   ></v-radio>
                                                   <v-radio
                                                      color="primary"
                                                      label="Facultad"
                                                      value="r-facultad"
                                                   ></v-radio>
                                                </v-radio-group>
                                             </div>
                                          </v-flex>
                                          <v-flex
                                             v-if="
                                                radioResumenGeneral ==
                                                'r-carrera'
                                             "
                                             xs12
                                          >
                                             <v-autocomplete
                                                v-model="selectCarrera"
                                                :items="cmbCarrera"
                                                label="Carrera"
                                                no-data-text="Sin resultados"
                                                item-text="nombre"
                                                item-value="carreraUniversitariaId"
                                             ></v-autocomplete>
                                          </v-flex>
                                          <v-flex
                                             v-if="
                                                radioResumenGeneral ==
                                                'r-facultad'
                                             "
                                             xs12
                                          >
                                             <v-autocomplete
                                                v-model="selectFacultad"
                                                :items="cmbFacultad"
                                                label="Facultad"
                                                no-data-text="Sin resultados"
                                                item-text="nombre"
                                                item-value="unidadAcademicaId"
                                             ></v-autocomplete>
                                          </v-flex>
                                       </v-layout>
                                    </v-expansion-panel-content>
                                 </v-expansion-panel>
                              </v-expansion-panels>
                           </v-flex>
                           <v-flex xs12 mt-2>
                              <v-btn
                                 color="green darken-3 white--text"
                                 block
                                 @click="
                                    reporteResumenGeneral(
                                       selectCarrera,
                                       selectFacultad
                                    )
                                 "
                              >
                                 <v-icon left>fa-file-excel</v-icon>
                                 Resumen general
                              </v-btn>
                           </v-flex>
                           <v-flex xs12 mt-2>
                              <v-btn
                                 color="primary white--text"
                                 block
                                 @click="generarCartasBecarios()"
                              >
                                 <v-icon left color="white"
                                    >fa-solid fa-envelope</v-icon
                                 >
                                 Generar Cartas
                              </v-btn>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>

                  <v-card-actions
                     style="
                        margin-top: -20px;
                        margin-right: 20px;
                        padding-bottom: 20px;
                     "
                  >
                     <v-spacer></v-spacer>
                     <v-btn
                        color="primary"
                        text
                        @click.native="dialogRepGrupales = false"
                        >Salir</v-btn
                     >
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>
         <v-dialog v-model="dialogReporteLoading" persistent width="300">
            <v-card color="primary" dark class="pt-5 pb-2">
               <v-card-text style="color: white">
                  Procesando...
                  <v-progress-linear
                     indeterminate
                     color="white"
                     class="mb-0"
                  ></v-progress-linear>
               </v-card-text>
            </v-card>
         </v-dialog>
         <!-- DIALOG REPORTES INDIVUDALES DE SOLICITUD -->
         <ReportesSoliBeca
            v-model="dialogRepIndividuales"
            :soli-beca-id="numeroCaso"
            :numero-ref="numeroRef"
            :carrera-id="carreraId"
         />

         <!-- OVERLAY DE PRESENTACIÓN -->
         <div v-if="modoPresentacion" class="presentation-overlay">
            <!-- Encabezado -->
            <div class="presentation-header">
               <div class="presentation-title">
                  <v-icon color="white" small class="mr-2">fas fa-desktop</v-icon>
                  <span>{{ seccionActualNombre }}</span>
               </div>
               <div class="presentation-counter">
                  {{ indexSeccionActual + 1 }} / {{ seccionesPresent.length }}
               </div>
               <v-btn icon dark small @click="modoPresentacion = false" title="Salir de presentación">
                  <v-icon small>fas fa-times</v-icon>
               </v-btn>
            </div>

            <!-- Diapositivas -->
            <div class="presentation-content">
               <transition name="page-flip" mode="out-in">
               <div :key="stepNum" class="slide-page">
               <!-- Cargando -->
               <div v-if="slideData.loadingSlide" class="slide-body slide-center">
                  <v-progress-circular indeterminate color="primary" size="56"></v-progress-circular>
               </div>

               <!-- SLIDE 3: Datos Generales -->
               <div v-else-if="stepNum == 3 && solicitudInfo" class="slide-body">
                  <div class="slide-section" style="align-items:stretch;">
                     <!-- Avatar + botones -->
                     <div class="slide-avatar-block">
                        <v-avatar size="80" color="primary darken-2">
                           <img v-if="solicitudInfo.profilePicturePath" :src="solicitudInfo.profilePicturePath" />
                           <v-icon v-else dark size="38">fas fa-user-graduate</v-icon>
                        </v-avatar>
                        <div class="slide-carnet mt-2">{{ solicitudInfo.carnet }}</div>
                        <div class="caption grey--text">{{ solicitudInfo.cicloDeAplicacion }}</div>
                        <div class="slide-avatar-actions mt-3">
                           <button class="slide-action-btn" @click="dialogSlideNotas = true">
                              <v-icon size="14">fas fa-graduation-cap</v-icon>
                              <span>Notas</span>
                           </button>
                           <button class="slide-action-btn" @click="dialogSlidePensum = true">
                              <v-icon size="14">fas fa-book-open</v-icon>
                              <span>Pensum</span>
                           </button>
                           <button class="slide-action-btn" @click="dialogSlideHistorialBecas = true">
                              <v-icon size="14">fas fa-history</v-icon>
                              <span>Historial</span>
                           </button>
                           <button class="slide-action-btn" @click="refreshSlideData">
                              <v-icon size="14">fas fa-sync-alt</v-icon>
                              <span>Refrescar</span>
                           </button>
                           <button class="slide-action-btn" @click="dialogSlideSolicitudes = true">
                              <v-icon size="14">fas fa-list</v-icon>
                              <span>Solicitudes</span>
                           </button>
                           <button class="slide-action-btn" @click="abrirDialogSlideEstado">
                              <v-icon size="14">fas fa-flag</v-icon>
                              <span>Estado</span>
                           </button>
                           <button class="slide-action-btn" @click="abrirDialogSlideTipoBeca">
                              <v-icon size="14">fas fa-tag</v-icon>
                              <span>Tipo Beca</span>
                           </button>
                        </div>
                     </div>

                     <!-- Grid unificado de 4 columnas con TODOS los campos -->
                     <div class="slide-grid slide-grid--4col" style="flex:1; align-content:stretch; height:100%;">
                        <!-- Fila 1: nombre, apellido e irregular -->
                        <div class="slide-field sf-wide"><span class="sf-label">Nombres</span><span class="sf-val">{{ solicitudInfo.nombres }}</span></div>
                        <div class="slide-field"><span class="sf-label">Apellidos</span><span class="sf-val">{{ solicitudInfo.apellidos }}</span></div>
                        <div class="slide-field"><span class="sf-label">Irregular acad.</span><span class="sf-val">{{ solicitudInfo.irregularmenteAcademico ? 'Sí' : 'No' }}</span></div>
                        <!-- Fila 2: carrera y email -->
                        <div class="slide-field sf-wide"><span class="sf-label">Carrera</span><span class="sf-val">{{ getNombreCarrera(solicitudInfo.carreraUniversitariaId) }}</span></div>
                        <div class="slide-field sf-wide"><span class="sf-label">Email</span><span class="sf-val">{{ solicitudInfo.email }}</span></div>
                        <!-- Fila 3: teléfonos, fechas, hijos -->
                        <div class="slide-field"><span class="sf-label">Tel. Principal</span><span class="sf-val">{{ solicitudInfo.telefonoPrincipal }}</span></div>
                        <div class="slide-field"><span class="sf-label">Tel. Secundario</span><span class="sf-val">{{ solicitudInfo.telefonoSecundario || '—' }}</span></div>
                        <div class="slide-field"><span class="sf-label">F. Nacimiento</span><span class="sf-val">{{ (solicitudInfo.fechaDeNacimiento || '').substr(0,10) }}</span></div>
                        <div class="slide-field"><span class="sf-label">F. Graduación</span><span class="sf-val">{{ (solicitudInfo.fechaDeGraduacion || '').substr(0,10) || '—' }}</span></div>
                        <!-- Fila 4: dirección, hijos, empleado -->
                        <div class="slide-field sf-wide"><span class="sf-label">Dirección</span><span class="sf-val">{{ solicitudInfo.direccion }}</span></div>
                        <div class="slide-field"><span class="sf-label">Hijos</span><span class="sf-val">{{ solicitudInfo.hijos }}</span></div>
                        <div class="slide-field"><span class="sf-label">Empleado (familiar)</span><span class="sf-val">{{ solicitudInfo.empleado || '—' }}</span></div>
                        <!-- Fila 5: unidad trabajo, beneficiario, estado -->
                        <div class="slide-field sf-wide"><span class="sf-label">Unidad de trabajo</span><span class="sf-val">{{ solicitudInfo.empleadoUnidadDeTrabajo || '—' }}</span></div>
                        <div class="slide-field sf-wide"><span class="sf-label">Beneficiario</span><span class="sf-val">{{ getNombreBeneficiario(solicitudInfo.beneficiarioId) }}</span></div>
                        <!-- Fila 6: asesor, estado, prioridad, ciclo -->
                        <div class="slide-field sf-wide"><span class="sf-label">Asesor</span><span class="sf-val">{{ getNombreAsesor(solicitudInfo.asesorId) }}</span></div>
                        <div class="slide-field"><span class="sf-label">Estado</span><span class="sf-val">{{ solicitudInfo.estadoCaso }}</span></div>
                        <div class="slide-field"><span class="sf-label">Tipo Beca</span><span class="sf-val">{{ getTipoBecaNombre(solicitudInfo.tipoBecaId) }}</span></div>
                        <div class="slide-field"><span class="sf-label">Prioridad</span><span class="sf-val">{{ ['Sin prioridad','2da opción','Candidato'][solicitudInfo.prioridad] || '—' }}</span></div>
                        <!-- Fila 7: beca anterior, patrocinador, congregación -->
                        <div class="slide-field"><span class="sf-label">Ha tenido beca</span><span class="sf-val">{{ solicitudInfo.hasTenidoBeca ? 'Sí' : 'No' }}</span></div>
                        <div class="slide-field sf-wide"><span class="sf-label">Origen beca anterior</span><span class="sf-val">{{ solicitudInfo.origenDeBecaAnterior || '—' }}</span></div>
                        <div class="slide-field"><span class="sf-label">Hermanos con beca</span><span class="sf-val">{{ solicitudInfo.hermanosConBeca ? 'Sí' : 'No' }}</span></div>
                        <!-- Fila 8: patrocinador, congregacion, flags -->
                        <div class="slide-field sf-wide"><span class="sf-label">Patrocinador</span><span class="sf-val">{{ solicitudInfo.patrocinador || 'Ninguno' }}</span></div>
                        <div class="slide-field"><span class="sf-label">Congregación</span><span class="sf-val">{{ solicitudInfo.congregacion || '—' }}</span></div>
                        <div class="slide-field"><span class="sf-label">Colaborador</span><span class="sf-val">{{ solicitudInfo.esColaborador ? 'Sí' : 'No' }}</span></div>
                        <!-- Fila 9: flags restantes -->
                        <div class="slide-field"><span class="sf-label">Bienestar Uni.</span><span class="sf-val">{{ solicitudInfo.bienestarUniversitario ? 'Sí' : 'No' }}</span></div>
                        <div class="slide-field"><span class="sf-label">Reaplicación</span><span class="sf-val">{{ solicitudInfo.reaplicacion ? 'Sí' : 'No' }}</span></div>
                        <div class="slide-field"><span class="sf-label">Proc. Graduación</span><span class="sf-val">{{ solicitudInfo.procesoDeGraduacion ? 'Sí' : 'No' }}</span></div>
                     </div>
                  </div>
               </div>

               <!-- SLIDE 3.1: Datos Laborales -->
               <div v-else-if="stepNum == 3.1" class="slide-body">
                  <table class="slide-table">
                     <thead>
                        <tr><th>Nombre</th><th>Parentesco</th><th>Lugar de trabajo</th><th>Jefe inmediato</th><th>Tiempo</th><th class="text-right">Salario</th></tr>
                     </thead>
                     <tbody>
                        <tr v-if="!slideData.laboral.length"><td colspan="6" class="slide-empty-row">Sin datos laborales registrados</td></tr>
                        <tr v-for="(r, i) in slideData.laboral" :key="i">
                           <td>{{ r.nombre }}</td>
                           <td>{{ r.parentesco }}</td>
                           <td>{{ r.lugarDeTrabajo }}</td>
                           <td>{{ r.jefeInmediato }}</td>
                           <td>
                              <span v-if="r.tiempoLaboralAnnios > 0">{{ r.tiempoLaboralAnnios }} año(s) y </span>
                              <span>{{ r.tiempoLaboralMeses }} meses</span>
                           </td>
                           <td class="text-right">$ {{ Number(r.salario || 0).toFixed(2) }}</td>
                        </tr>
                     </tbody>
                  </table>
               </div>

               <!-- SLIDE 3.2: Núcleo Familiar -->
               <div v-else-if="stepNum == 3.2" class="slide-body">
                  <table class="slide-table">
                     <thead>
                        <tr><th>Nombre</th><th>Parentesco</th><th>Profesión</th><th>Edad</th><th>¿Estudia?</th><th>Institución educativa</th></tr>
                     </thead>
                     <tbody>
                        <tr v-if="!slideData.nucleo.length"><td colspan="6" class="slide-empty-row">Sin miembros registrados</td></tr>
                        <tr v-for="(r, i) in slideData.nucleo" :key="i">
                           <td>{{ r.nombre }}</td>
                           <td>{{ r.parentesco }}</td>
                           <td>{{ r.profesion }}</td>
                           <td>{{ r.edad }}</td>
                           <td>{{ r.esEstudiante ? 'Sí' : 'No' }}</td>
                           <td>{{ r.institucionEducativa }}</td>
                        </tr>
                     </tbody>
                  </table>
               </div>

               <!-- SLIDE 3.3: Bienes Familiares -->
               <div v-else-if="stepNum == 3.3" class="slide-body slide-body--2col">
                  <div class="slide-card">
                     <div class="slide-card-title"><v-icon left color="primary" small>fas fa-home</v-icon>Vivienda</div>
                     <template v-if="slideData.bienes">
                        <div class="slide-field"><span class="sf-label">Tipo</span><span class="sf-val">{{ slideData.bienes.tipoVivienda || slideData.bienes.tipoDeVivienda || '—' }}</span></div>
                        <div class="slide-field"><span class="sf-label">Material</span><span class="sf-val">{{ slideData.bienes.materialVivienda || slideData.bienes.materialDeVivienda || '—' }}</span></div>
                     </template>
                     <div v-else class="sf-val grey--text">Sin datos</div>
                     <!-- Fotos de vivienda -->
                     <div class="slide-card-title mt-3"><v-icon left color="primary" small>fas fa-camera</v-icon>Foto de vivienda</div>
                     <div v-if="slideData.fotoVivienda.length" class="comprobante-grid" style="margin-top:8px;">
                        <div v-for="(f, i) in slideData.fotoVivienda" :key="i"
                           class="comprobante-burbuja"
                           @click="abrirVisor({ path: f.fotoPath, comprobante: etiquetaFotoVivienda(f.tipoFoto) })">
                           <div class="burbuja-icono">
                              <v-icon color="primary" size="28">fas fa-image</v-icon>
                           </div>
                           <div class="burbuja-nombre">{{ etiquetaFotoVivienda(f.tipoFoto) }}</div>
                        </div>
                     </div>
                     <div v-else class="caption grey--text mt-1">Sin fotos registradas</div>
                  </div>
                  <div class="slide-card">
                     <div class="slide-card-title"><v-icon left color="primary" small>fas fa-car</v-icon>Vehículo</div>
                     <template v-if="slideData.bienes">
                        <div class="slide-field"><span class="sf-label">¿Posee vehículo?</span><span class="sf-val">{{ slideData.bienes.numeroDePlaca != null ? 'Sí' : 'No' }}</span></div>
                        <template v-if="slideData.bienes.numeroDePlaca != null">
                           <div class="slide-field"><span class="sf-label">Tipo vehículo</span><span class="sf-val">{{ slideData.bienes.tipoDeVehiculo || slideData.bienes.tipoDeVehiculoId || '—' }}</span></div>
                           <div class="slide-field"><span class="sf-label">Placa</span><span class="sf-val">{{ slideData.bienes.numeroDePlaca || '—' }}</span></div>
                           <div class="slide-field"><span class="sf-label">Modelo</span><span class="sf-val">{{ slideData.bienes.modelo || '—' }}</span></div>
                           <div class="slide-field"><span class="sf-label">Año</span><span class="sf-val">{{ slideData.bienes.annio || '—' }}</span></div>
                        </template>
                     </template>
                     <div v-else class="sf-val grey--text">Sin datos</div>
                  </div>
               </div>

               <!-- SLIDE 3.4: Ingresos y Egresos -->
               <div v-else-if="stepNum == 3.4" class="slide-body slide-body--2col">
                  <div class="slide-card">
                     <div class="slide-card-title"><v-icon left color="green darken-2" small>fas fa-arrow-circle-down</v-icon>Ingresos</div>
                     <table class="slide-table slide-table--compact">
                        <thead><tr><th>Tipo</th><th>Descripción</th><th class="text-right">Monto</th><th class="text-center">Comprobante</th></tr></thead>
                        <tbody>
                           <tr v-if="!slideData.ingresos.length"><td colspan="4" class="slide-empty-row">Sin ingresos</td></tr>
                           <tr v-for="(r, i) in slideData.ingresos" :key="i">
                              <td>{{ r.ingreso }}</td>
                              <td>
                                 <span v-if="r.descripcion" class="td-clamp" @click="verDescripcionCompleta(r.descripcion)">{{ r.descripcion }}</span>
                                 <span v-else>—</span>
                              </td>
                              <td class="text-right">$ {{ Number(r.monto || 0).toFixed(2) }}</td>
                              <td class="text-center">
                                 <div v-if="r.comprobantePath" class="comp-burbuja-mini" @click="abrirVisor({ path: r.comprobantePath, comprobante: r.ingreso })">
                                    <v-icon size="14" color="white">{{ esImagen(r.comprobantePath) ? 'fas fa-image' : 'fas fa-file-pdf' }}</v-icon>
                                 </div>
                                 <span v-else class="grey--text caption">—</span>
                              </td>
                           </tr>
                        </tbody>
                        <tfoot><tr><td colspan="2" class="text-right font-weight-bold">Total</td><td class="text-right font-weight-bold">$ {{ totalIngresos }}</td><td></td></tr></tfoot>
                     </table>
                  </div>
                  <div class="slide-card">
                     <div class="slide-card-title"><v-icon left color="red darken-2" small>fas fa-arrow-circle-up</v-icon>Egresos</div>
                     <table class="slide-table slide-table--compact">
                        <thead><tr><th>Tipo</th><th>Descripción</th><th class="text-right">Monto</th><th class="text-center">Comprobante</th></tr></thead>
                        <tbody>
                           <tr v-if="!slideData.egresos.length"><td colspan="4" class="slide-empty-row">Sin egresos</td></tr>
                           <tr v-for="(r, i) in slideData.egresos" :key="i">
                              <td>{{ r.egreso }}</td>
                              <td>
                                 <span v-if="r.descripcion" class="td-clamp" @click="verDescripcionCompleta(r.descripcion)">{{ r.descripcion }}</span>
                                 <span v-else>—</span>
                              </td>
                              <td class="text-right">$ {{ Number(r.monto || 0).toFixed(2) }}</td>
                              <td class="text-center">
                                 <div v-if="r.comprobantePath" class="comp-burbuja-mini" @click="abrirVisor({ path: r.comprobantePath, comprobante: r.egreso })">
                                    <v-icon size="14" color="white">{{ esImagen(r.comprobantePath) ? 'fas fa-image' : 'fas fa-file-pdf' }}</v-icon>
                                 </div>
                                 <span v-else class="grey--text caption">—</span>
                              </td>
                           </tr>
                        </tbody>
                        <tfoot><tr><td colspan="2" class="text-right font-weight-bold">Total</td><td class="text-right font-weight-bold">$ {{ totalEgresos }}</td><td></td></tr></tfoot>
                     </table>
                  </div>
               </div>

               <!-- SLIDE 3.5: Ensayo -->
               <div v-else-if="stepNum == 3.5" class="slide-body slide-body--essay">
                  <p class="slide-essay">{{ slideData.ensayo || 'Sin ensayo registrado.' }}</p>
               </div>

               <!-- SLIDE 4: Comprobantes -->
               <div v-else-if="stepNum == 4" class="slide-body slide-body--comprobantes">
                  <div v-if="!slideData.comprobantes.length" class="slide-center" style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center">
                     <v-icon size="64" color="grey lighten-1" class="mb-3">fas fa-folder-open</v-icon>
                     <div class="grey--text">Sin comprobantes subidos</div>
                  </div>
                  <div v-else class="comprobante-grid">
                     <div
                        v-for="(c, i) in slideData.comprobantes"
                        :key="i"
                        class="comprobante-burbuja"
                        :class="{ 'burbuja--validado': c.validado }"
                        @click="abrirVisor(c)"
                     >
                        <div class="burbuja-icono">
                           <v-icon :color="c.validado ? 'green darken-2' : 'primary'" size="48">
                              {{ esImagen(c.path) ? 'fas fa-image' : 'fas fa-file-pdf' }}
                           </v-icon>
                        </div>
                        <div class="burbuja-nombre">{{ c.comprobante }}</div>
                        <v-icon v-if="c.validado" class="burbuja-check" color="green darken-2" size="14">fas fa-check-circle</v-icon>
                     </div>
                  </div>
                  <div v-if="solicitudInfo && solicitudInfo.comentarioAsesor" class="slide-comment mt-3" style="font-size:18px;">
                     <span class="sf-label">Comentario asesor: </span>{{ solicitudInfo.comentarioAsesor }}
                  </div>
                  <div v-if="solicitudInfo && solicitudInfo.comentarioAdministrador" class="slide-comment mt-2" style="border-color:#A00402; background:#fff0f0; font-size:18px;">
                     <span class="sf-label">Comentario admin: </span>{{ solicitudInfo.comentarioAdministrador }}
                  </div>
               </div>
               </div>
               </transition>
            </div>

            <!-- Visor zoom global (disponible en cualquier slide) -->
            <transition name="visor-fade">
               <div v-if="slideViewer.show" class="visor-overlay" @click.self="slideViewer.show = false">
                  <div class="visor-card">
                     <div class="visor-header">
                        <span class="visor-titulo">{{ slideViewer.nombre }}</span>
                        <v-btn icon dark small @click="slideViewer.show = false">
                           <v-icon>fas fa-times</v-icon>
                        </v-btn>
                     </div>
                     <div class="visor-body">
                        <img v-if="esImagen(slideViewer.url)" :src="normalizarRuta(slideViewer.url)" class="visor-img" />
                        <iframe v-else :src="normalizarRuta(slideViewer.url)" class="visor-iframe" frameborder="0"></iframe>
                     </div>
                  </div>
               </div>
            </transition>

            <!-- Dialogs auxiliares del modo presentación -->
            <v-dialog v-model="dialogSlideNotas" eager fullscreen>
               <v-card class="d-flex flex-column" style="height:100vh; overflow:hidden;">
                  <v-toolbar dark color="primary" dense flat>
                     <v-icon class="mr-2" small>fas fa-graduation-cap</v-icon>
                     <v-toolbar-title>Historial de notas — {{ solicitudInfo ? solicitudInfo.carnet : '' }}</v-toolbar-title>
                     <v-spacer></v-spacer>
                     <v-btn icon dark @click="dialogSlideNotas = false"><v-icon small>fas fa-times</v-icon></v-btn>
                  </v-toolbar>
                  <v-card-text class="text--primary flex-grow-1 pa-0" style="overflow:hidden;">
                     <RecordAlu v-if="solicitudInfo" :carnet="solicitudInfo.carnet" :show-dialog="dialogSlideNotas" />
                  </v-card-text>
               </v-card>
            </v-dialog>

            <v-dialog v-model="dialogSlidePensum" eager fullscreen>
               <v-card class="d-flex flex-column" style="height:100vh; overflow:hidden;">
                  <v-toolbar dark color="primary" dense flat>
                     <v-icon class="mr-2" small>fas fa-book-open</v-icon>
                     <v-toolbar-title>Pensum — {{ solicitudInfo ? solicitudInfo.carnet : '' }}</v-toolbar-title>
                     <v-spacer></v-spacer>
                     <v-btn icon dark @click="dialogSlidePensum = false"><v-icon small>fas fa-times</v-icon></v-btn>
                  </v-toolbar>
                  <v-card-text class="flex-grow-1 pa-2 text--primary" style="overflow:hidden; height:calc(100vh - 48px);">
                     <Pensum v-if="solicitudInfo" ref="pensumSlide" :carnet="solicitudInfo.carnet" />
                  </v-card-text>
               </v-card>
            </v-dialog>

            <v-dialog v-model="dialogSlideHistorialBecas" max-width="1200px">
               <v-card class="pt-6">
                  <v-card-text class="text--primary">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <HistorialBecas v-if="dialogSlideHistorialBecas && solicitudInfo" :carnet="solicitudInfo.carnet" />
                        </v-layout>
                     </v-container>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                     <v-btn outlined color="primary" min-width="150" @click="dialogSlideHistorialBecas = false">Salir</v-btn>
                  </v-card-actions>
               </v-card>
            </v-dialog>

            <!-- Dialog: lista de solicitudes para navegar sin salir de presentación -->
            <v-dialog v-model="dialogSlideSolicitudes" max-width="820" persistent>
               <v-card>
                  <v-card-title class="subtitle-1 font-weight-bold primary white--text py-3 px-4">
                     <v-icon small dark class="mr-2">fas fa-list</v-icon>
                     Solicitudes — {{ selectCiclo }}
                     <v-spacer></v-spacer>
                     <v-btn icon dark small @click="dialogSlideSolicitudes = false">
                        <v-icon small>fas fa-times</v-icon>
                     </v-btn>
                  </v-card-title>
                  <v-card-text class="pt-3 pb-2 px-4">
                     <v-progress-linear v-if="loadingSlideSolicitudes" indeterminate color="primary" class="mb-2"></v-progress-linear>
                     <div class="d-flex">
                        <v-autocomplete
                           v-model="slideFiltrosBeneficiario"
                           :items="cmbBeneficiario"
                           item-value="beneficiarioId"
                           item-text="nombre"
                           label="Beneficiario"
                           outlined
                           dense
                           clearable
                           hide-details
                           class="mr-2 mb-3"
                        ></v-autocomplete>
                        <v-autocomplete
                           v-model="slideFiltrosTipoBeneficio"
                           :items="cmbTipoBeneficio"
                           item-value="tipoBeneficioId"
                           item-text="nombre"
                           label="Tipo Beneficiario"
                           outlined
                           dense
                           clearable
                           hide-details
                           class="mb-3"
                        ></v-autocomplete>
                     </div>
                     <v-text-field
                        v-model="slideSolicitudesSearch"
                        label="Buscar por carnet, nombre o apellido"
                        prepend-inner-icon="fas fa-search"
                        outlined
                        dense
                        clearable
                        hide-details
                        class="mb-3"
                     ></v-text-field>
                     <v-data-table
                        :headers="[
                           { text: 'Vista',     value: 'vista',     width: '60px',  sortable: false },
                           { text: 'Carnet',    value: 'carnet',    width: '120px' },
                           { text: 'Nombres',   value: 'nombres',   width: '150px' },
                           { text: 'Apellidos', value: 'apellidos', width: '150px' },
                           { text: 'Estado',    value: 'estadoCaso', width: '130px' },
                           { text: '',          value: 'accion',    width: '50px',  sortable: false }
                        ]"
                        :items="solicitudesFiltradas"
                        :search="slideSolicitudesSearch"
                        :items-per-page="10"
                        :footer-props="{ itemsPerPageOptions: [10, 25], itemsPerPageText: 'Filas:' }"
                        :item-class="item => vistasIds.includes(item.solicitudBecaId) ? 'fila-vista' : ''"
                        dense
                        class="elevation-0"
                        style="cursor:pointer;"
                        @click:row="cargarSolicitudEnSlide"
                     >
                        <template #item.vista="{ item }">
                           <v-simple-checkbox
                              :value="vistasIds.includes(item.solicitudBecaId)"
                              color="primary"
                              @click.stop="toggleVista(item)"
                           ></v-simple-checkbox>
                        </template>
                        <template #item.estadoCaso="{ item }">
                           <v-chip x-small :color="getColorEstadoSoli(item)" dark>{{ item.estadoCaso }}</v-chip>
                        </template>
                        <template #item.accion="{ item }">
                           <v-btn icon small :loading="loadingCargarSolicitud" @click.stop="cargarSolicitudEnSlide(item)">
                              <v-icon small color="primary">fas fa-eye</v-icon>
                           </v-btn>
                        </template>
                     </v-data-table>
                  </v-card-text>
               </v-card>
            </v-dialog>

            <!-- Dialog: editar Estado de Beca desde presentación -->
            <v-dialog v-model="dialogSlideEstado" max-width="400" persistent>
               <v-card>
                  <v-card-title class="subtitle-1 font-weight-bold primary white--text py-3 px-4">
                     <v-icon small dark class="mr-2">fas fa-flag</v-icon>
                     Estado de Beca
                  </v-card-title>
                  <v-card-text class="pt-4 pb-2">
                     <v-autocomplete
                        v-model="slideEstadoId"
                        :items="cmbEstadoCasoSlide"
                        item-text="nombre"
                        item-value="estadoCasoId"
                        label="Estado"
                        outlined
                        dense
                        hide-details
                     ></v-autocomplete>
                  </v-card-text>
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn text @click="dialogSlideEstado = false">Cancelar</v-btn>
                     <v-btn color="primary" :loading="loadingSlideEstado" @click="guardarEstadoSlide">Guardar</v-btn>
                  </v-card-actions>
               </v-card>
            </v-dialog>

            <!-- Dialog: editar Tipo de Beca desde presentación -->
            <v-dialog v-model="dialogSlideTipoBeca" max-width="400" persistent>
               <v-card>
                  <v-card-title class="subtitle-1 font-weight-bold primary white--text py-3 px-4">
                     <v-icon small dark class="mr-2">fas fa-tag</v-icon>
                     Tipo de Beca
                  </v-card-title>
                  <v-card-text class="pt-4 pb-2">
                     <v-autocomplete
                        v-model="slideTipoBecaId"
                        :items="cmbTipoBecaSlide"
                        item-text="descripcion"
                        item-value="tipoBecaId"
                        label="Tipo de Beca"
                        outlined
                        dense
                        hide-details
                     ></v-autocomplete>
                  </v-card-text>
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn text @click="dialogSlideTipoBeca = false">Cancelar</v-btn>
                     <v-btn color="primary" :loading="loadingSlideTipoBeca" @click="guardarTipoBecaSlide">Guardar</v-btn>
                  </v-card-actions>
               </v-card>
            </v-dialog>

            <v-dialog v-model="slideDescPopup.show" max-width="520px">
               <v-card>
                  <v-card-title class="subtitle-1 font-weight-bold primary white--text py-3 px-4">
                     Descripción completa
                     <v-spacer></v-spacer>
                     <v-btn icon dark small @click="slideDescPopup.show = false"><v-icon small>fas fa-times</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text class="pt-4 pb-3 px-4 body-2 text--primary" style="white-space:pre-wrap; line-height:1.6;">{{ slideDescPopup.text }}</v-card-text>
               </v-card>
            </v-dialog>

            <!-- Dialog: confirmar si marcar como vista al abrir solicitud -->
            <v-dialog v-model="dialogConfirmVista" max-width="420" persistent>
               <v-card>
                  <v-card-title class="subtitle-1 font-weight-bold primary white--text py-3 px-4">
                     <v-icon small dark class="mr-2">fas fa-eye</v-icon>
                     Abrir solicitud
                  </v-card-title>
                  <v-card-text class="pt-4 pb-2 body-2 text--primary">
                     Al abrir esta solicitud de beca, ¿desea marcarla automáticamente como <strong>vista</strong>?
                  </v-card-text>
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn text @click="confirmarAbrirSinVista">No</v-btn>
                     <v-btn color="primary" @click="confirmarAbrirConVista">Sí</v-btn>
                  </v-card-actions>
               </v-card>
            </v-dialog>

            <!-- Toast de feedback dentro del overlay -->
            <transition name="slide-toast">
               <div v-if="slideToast" class="slide-toast" :class="`slide-toast--${slideToastColor}`">
                  <v-icon small dark class="mr-2">{{ slideToastColor === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle' }}</v-icon>
                  {{ slideToastText }}
               </div>
            </transition>

            <!-- Navegación inferior: secciones directas -->
            <div class="presentation-nav">
               <button
                  v-for="(s, i) in seccionesPresent"
                  :key="i"
                  class="nav-sec-btn"
                  :class="{ 'nav-sec-btn--active': i === indexSeccionActual }"
                  @click="stepNum = s.step"
               >
                  <span class="nav-sec-num">{{ i + 1 }}</span>
                  <span class="nav-sec-label">{{ s.nombre }}</span>
               </button>
            </div>
         </div>

         <!-- CONTAINER VER SOLICITUD -->
         <v-container v-if="verNuevo" :fluid="$vuetify.breakpoint.mdAndDown">
            <v-layout wrap>
               <v-flex xs12 text-center mb-4>
                  <v-btn
                     rounded
                     outlined
                     largec
                     class="mr-1"
                     color="primary"
                     @click="regresar"
                     >Regresar</v-btn
                  >
                  <v-btn
                     v-if="checkModificarAsesor()"
                     rounded
                     outlined
                     large
                     class="ml-1"
                     color="primary"
                     @click="dialogRepIndividuales = true"
                     >Reportes individuales</v-btn
                  >
                  <v-switch
                     v-if="puedeVerModoPresentacion"
                     v-model="modoPresentacion"
                     color="primary"
                     dense
                     hide-details
                     class="d-inline-flex ml-4 mt-0 pt-0"
                     label="Diseño Presentación"
                  ></v-switch>
               </v-flex>
               <v-flex class="font-weight-medium text-h6" xs12 text-center mb-4>
                  Su número de referencia es: <br />
                  <span class="colorPrimary font-weight-bold">
                     {{ solicitudBecaRef }}
                  </span>
               </v-flex>
            </v-layout>

            <v-stepper
               v-model="stepNum"
               non-linear
               :class="$vuetify.breakpoint.xsOnly ? 'elevation-0' : ''"
            >
               <v-stepper-header
                  v-if="solicitudBeneId != null"
                  style="overflow: hidden"
               >
                  <v-stepper-step editable step="3">
                     Datos generales
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                     editable
                     step="3.1"
                  >
                     Datos laborales
                  </v-stepper-step>

                  <v-divider
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                  ></v-divider>

                  <v-stepper-step
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                     editable
                     step="3.2"
                  >
                     Datos familiares
                  </v-stepper-step>

                  <v-divider
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                  ></v-divider>

                  <v-stepper-step
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                     editable
                     step="3.3"
                  >
                     Bienes familiares
                  </v-stepper-step>

                  <v-divider
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                  ></v-divider>

                  <v-stepper-step
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                     editable
                     step="3.4"
                  >
                     Ingresos y egresos
                  </v-stepper-step>

                  <v-divider
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 4 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                  ></v-divider>

                  <v-stepper-step
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                     editable
                     step="3.5"
                  >
                     Ensayo
                  </v-stepper-step>

                  <v-divider
                     v-if="
                        solicitudBeneId == 1 ||
                        solicitudBeneId == 2 ||
                        solicitudBeneId == 8 ||
                        solicitudBeneId == 9
                     "
                  ></v-divider>

                  <v-stepper-step editable step="4">
                     Comprobantes
                  </v-stepper-step>
               </v-stepper-header>

               <v-stepper-items
                  :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'py-2'"
               >
                  <!-- PASO 3 -->
                  <v-stepper-content
                     step="3"
                     :style="
                        $vuetify.breakpoint.xsOnly
                           ? 'margin: 0px 0px; padding: 0px 0px;'
                           : ''
                     "
                  >
                     <FormBecasDatosGenerales
                        :solicitud-info-prop="solicitudInfo"
                        @nextStep="nextStepDatosGenerales($event)"
                     />
                  </v-stepper-content>

                  <!-- PASO 3.1 -->
                  <v-stepper-content
                     step="3.1"
                     :style="
                        $vuetify.breakpoint.xsOnly
                           ? 'margin: 0px 0px; padding: 0px 0px;'
                           : ''
                     "
                  >
                     <FormBecasLaboral
                        :solicitud-beca-id="solicitudBecaId"
                        :completada="completada"
                        @cancelGoStep="stepNum = $event"
                        @nextStep="stepNum = $event"
                     />
                  </v-stepper-content>

                  <!-- PASO 3.2 -->
                  <v-stepper-content
                     step="3.2"
                     :style="
                        $vuetify.breakpoint.xsOnly
                           ? 'margin: 0px 0px; padding: 0px 0px;'
                           : ''
                     "
                  >
                     <FormBecasNucleoFamiliar
                        :solicitud-beca-id="solicitudBecaId"
                        :completada="completada"
                        @cancelGoStep="stepNum = $event"
                        @nextStep="stepNum = $event"
                     />
                  </v-stepper-content>

                  <!-- PASO 3.3 -->
                  <v-stepper-content
                     step="3.3"
                     :style="
                        $vuetify.breakpoint.xsOnly
                           ? 'margin: 0px 0px; padding: 0px 0px;'
                           : ''
                     "
                  >
                     <FormBecasBienesFamiliares
                        :solicitud-beca-id="solicitudBecaId"
                        :completada="completada"
                        @cancelGoStep="stepNum = $event"
                        @nextStep="stepNum = $event"
                     />
                  </v-stepper-content>

                  <!-- PASO 3.4 -->
                  <v-stepper-content
                     step="3.4"
                     :style="
                        $vuetify.breakpoint.xsOnly
                           ? 'margin: 0px 0px; padding: 0px 0px;'
                           : ''
                     "
                  >
                     <FormBecasContIngresosEgresos
                        :solicitud-beca-id="solicitudBecaId"
                        :completada="completada"
                        @cancelGoStep="stepNum = $event"
                        @nextStep="stepNum = $event"
                     />
                  </v-stepper-content>

                  <!-- PASO 3.5 -->
                  <v-stepper-content
                     step="3.5"
                     :style="
                        $vuetify.breakpoint.xsOnly
                           ? 'margin: 0px 0px; padding: 0px 0px;'
                           : ''
                     "
                  >
                     <FormBecasEnsayo
                        :solicitud-beca-id="solicitudBecaId"
                        :completada="completada"
                        @cancelGoStep="stepNum = $event"
                        @nextStep="stepNum = $event"
                     />
                  </v-stepper-content>

                  <!-- PASO 4 -->
                  <v-stepper-content
                     step="4"
                     :style="
                        $vuetify.breakpoint.xsOnly
                           ? 'margin: 0px 0px; padding: 0px 0px;'
                           : ''
                     "
                  >
                     <FormBecasComprobantes
                        :solicitud-beca-id="solicitudBecaId"
                        :beneficiario-id="selectBeneficiario"
                        :listar="stepNum == 4"
                        :completada="completada"
                        @cancelGoStep="stepNum = $event"
                     />
                  </v-stepper-content>
               </v-stepper-items>
            </v-stepper>
         </v-container>

         <!-- LISTA DE SOLICITUDES -->
         <v-card v-if="!verNuevo" elevation="0" outlined max-width="5000">
            <v-toolbar color="primary" dark>
               <v-toolbar-title style="font-weight: 500">
                  Solicitudes de becas
               </v-toolbar-title>
               <div class="mt-6 ml-3" style="width: 90px">
                  <v-autocomplete
                     v-model="selectCiclo"
                     label="Ciclo"
                     :items="cmbCiclosBecas"
                     no-data-text="Sin resultados"
                  >
                  </v-autocomplete>
               </div>
               <div
                  v-if="checkRangoAlto()"
                  class="mt-6 ml-3"
                  style="width: 120px"
               >
                  <v-autocomplete
                     v-model="selectEsReaplicacion"
                     label="Tipo"
                     item-value="id"
                     item-text="nombre"
                     :items="cmbEsReaplicacion"
                     no-data-text="Sin resultados"
                  >
                  </v-autocomplete>
               </div>
               <v-spacer></v-spacer>
               <v-text-field
                  v-if="
                     !showFilterAsesor &&
                     !showFilterBeneficio &&
                     !showFilterBeneficiario
                  "
                  ref="txtBusqueda"
                  v-model="searchComputed"
                  append-icon="fa-search"
                  class="mt-6"
                  color="white"
                  label="Busqueda"
                  single-line
               ></v-text-field>
               <v-autocomplete
                  v-if="checkRangoAlto() && showFilterAsesor"
                  v-model="selectAsesorFilter"
                  class="mt-6"
                  :items="cmbAsesores"
                  item-value="id"
                  item-text="userClaims[0].claimValue"
                  placeholder="Filtrar por asesor"
                  color="white"
               ></v-autocomplete>
               <v-autocomplete
                  v-if="checkRangoAlto() && showFilterBeneficio"
                  v-model="selectTipoBeneficio"
                  class="mt-6"
                  :items="cmbTipoBeneficio"
                  item-value="tipoBeneficioId"
                  item-text="nombre"
                  placeholder="Filtrar por beneficio"
                  color="white"
               ></v-autocomplete>
               <v-autocomplete
                  v-if="checkRangoAlto() && showFilterBeneficiario"
                  v-model="selectBeneficiarioFiltro"
                  class="mt-6"
                  :items="cmbBeneficiario"
                  item-value="beneficiarioId"
                  item-text="nombre"
                  placeholder="Filtrar por beneficiario"
                  color="white"
               ></v-autocomplete>
               <v-spacer></v-spacer>

               <v-btn
                  v-if="checkRangoAlto() && selectCiclo != cicloActual"
                  text
                  dark
                  @click="showDialogReaplicacion"
               >
                  Reaplicación <v-icon right>fa-redo-alt</v-icon>
               </v-btn>

               <v-btn
                  v-if="checkRangoAlto()"
                  text
                  dark
                  @click="dialogRepGrupales = true"
               >
                  Reportes <v-icon right>fa-print</v-icon>
               </v-btn>

               <v-btn
                  v-if="checkModificarAsesor()"
                  text
                  dark
                  @click="dialogoBloquear = true"
               >
                  Bloquear
                  <v-icon right color="white">fa-duotone fa-ban</v-icon>
               </v-btn>

               <v-dialog v-model="dialogoBloquear" width="290">
                  <v-card>
                     <v-card-title class="text-h6"> </v-card-title>

                     <v-card-text
                        class="text-center text-subtitle-1 font-weight-bold"
                     >
                        ¿Esta seguro que quiere bloquear todas las solicitudes
                        de becas?
                     </v-card-text>

                     <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="primary" text @click="bloquearbecas()">
                           Si
                        </v-btn>

                        <v-btn
                           color="primary"
                           text
                           @click="dialogoBloquear = false"
                        >
                           No
                        </v-btn>
                     </v-card-actions>
                  </v-card>
               </v-dialog>
            </v-toolbar>
            <!-- DATATABLE SOLICITUDES -->
            <v-data-table
               :headers="headers"
               :items="filteredSolicitudes"
               :loading="loadingSolicitudes"
               fixed-header
               :sort-by.sync="soliSortBy"
               :sort-desc.sync="soliSortDesc"
               :page.sync="soliPage"
               :items-per-page.sync="soliItemsPerPage"
               height="64vh"
               no-data-text="No se encontraron solicitudes de beca."
               loading-text="Listando solicitudes de beca, por favor espere..."
               :search="search"
               multi-sort
               :footer-props="footerByUser(oidcUser)"
               class="elevation-0 mt-3"
            >
               <!-- Filtros de busqueda -->
               <template #footer="{}">
                  <tr>
                     <td :colspan="headers.length">
                        <v-layout align-center justify-start fill-height>
                           <div class="mx-4">
                              <span class="text-body-1 font-weight-medium">
                                 Buscar por
                              </span>
                           </div>
                           <div style="margin-top: 5px">
                              <v-radio-group
                                 v-model="radiosBusqueda"
                                 row
                                 @change="cambiaRadios"
                              >
                                 <v-radio
                                    label="Carnet"
                                    color="primary"
                                    value="r-carnet"
                                 ></v-radio>
                                 <v-radio
                                    label="Nombres"
                                    color="primary"
                                    value="r-nombres"
                                 ></v-radio>
                                 <v-radio
                                    label="Apellidos"
                                    color="primary"
                                    value="r-apellidos"
                                 ></v-radio>
                                 <v-radio
                                    label="Carrera"
                                    color="primary"
                                    value="r-carrera"
                                 ></v-radio>
                                 <v-radio
                                    label="Beneficiario"
                                    color="primary"
                                    value="r-beneficiario"
                                 ></v-radio>
                                 <v-radio
                                    v-if="
                                       oidcUser.nivelasesor == 0 ||
                                       oidcUser.nivelasesor > 1 ||
                                       oidcUser.role == 'admin'
                                    "
                                    label="Tipo beneficio"
                                    color="primary"
                                    value="r-tipobeneficio"
                                 ></v-radio>
                                 <v-radio
                                    label="Fecha de solicitud"
                                    color="primary"
                                    value="r-fecha"
                                 ></v-radio>
                                 <v-radio
                                    v-if="
                                       oidcUser.nivelasesor == 0 ||
                                       oidcUser.nivelasesor > 1 ||
                                       oidcUser.role == 'admin'
                                    "
                                    label="Asesor"
                                    color="primary"
                                    value="r-asesor"
                                 ></v-radio>
                                 <v-radio
                                    label="Estado"
                                    color="primary"
                                    value="r-estado"
                                 ></v-radio>
                              </v-radio-group>
                           </div>
                        </v-layout>
                     </td>
                  </tr>
               </template>

               <template #item.prioridad="{ item }">
                  <v-tooltip
                     v-if="item.prioridad == 0"
                     bottom
                     max-width="300"
                     color="primary"
                  >
                     <template #activator="{ on }">
                        <v-icon size="18" color="primary" v-on="on"
                           >fas fa-circle</v-icon
                        >
                     </template>
                     <span style="font-size: 15px">Sin prioridad</span>
                  </v-tooltip>
                  <v-tooltip
                     v-if="item.prioridad == 1"
                     bottom
                     max-width="300"
                     color="amber darken-3"
                  >
                     <template #activator="{ on }">
                        <v-icon size="18" color="amber darken-3" v-on="on"
                           >fas fa-circle</v-icon
                        >
                     </template>
                     <span style="font-size: 15px">Segunda opción</span>
                  </v-tooltip>
                  <v-tooltip
                     v-if="item.prioridad == 2"
                     bottom
                     max-width="300"
                     color="green darken-2"
                  >
                     <template #activator="{ on }">
                        <v-icon size="18" color="green darken-2" v-on="on"
                           >fas fa-circle</v-icon
                        >
                     </template>
                     <span style="font-size: 15px">Candidato</span>
                  </v-tooltip>
               </template>
               <template #item.completada="{ item }">
                  <v-tooltip
                     v-if="item.completada"
                     bottom
                     max-width="300"
                     color="primary"
                  >
                     <template #activator="{ on }">
                        <v-icon
                           color="primary"
                           v-on="on"
                           @click="
                              checkRangoAlto()
                                 ? alternarCompletado(item)
                                 : false
                           "
                           >fas fa-check</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> Si </span>
                  </v-tooltip>
                  <v-tooltip v-else bottom max-width="300" color="primary">
                     <template #activator="{ on }">
                        <v-icon
                           color="primary"
                           v-on="on"
                           @click="
                              checkRangoAlto()
                                 ? alternarCompletado(item)
                                 : false
                           "
                           >fas fa-times</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> No </span>
                  </v-tooltip>
               </template>
               <template #item.notificado="{ item }">
                  <v-tooltip
                     v-if="item.notificado"
                     bottom
                     max-width="300"
                     color="primary"
                  >
                     <template #activator="{ on }">
                        <v-icon color="primary" v-on="on"
                           >fas fa-envelope-open-text</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> Enviada </span>
                  </v-tooltip>
                  <v-tooltip v-else bottom max-width="300" color="primary">
                     <template #activator="{ on }">
                        <v-icon
                           color="primary"
                           :disabled="
                              reenviando && reenviandoId == item.solicitudBecaId
                           "
                           v-on="on"
                           @click="
                              checkRangoAlto() && !reenviando
                                 ? reenviarSolicitud(item)
                                 : false
                           "
                        >
                           {{
                              reenviando && reenviandoId == item.solicitudBecaId
                                 ? 'fas fa-circle-notch fa-spin'
                                 : 'far fa-envelope'
                           }}
                        </v-icon>
                     </template>
                     <div style="font-size: 15px; text-align: center">
                        No se pudo enviar, <br />
                        has clic para reenviar
                     </div>
                  </v-tooltip>
               </template>
               <template #item.estadoCaso="{ item }">
                  <v-chip
                     :color="getColorEstadoSoli(item)"
                     dark
                     @click="getLog(item)"
                  >
                     <span>{{ item.estadoCaso }}</span>
                  </v-chip>
               </template>

               <template #item.asesorId="{ item }">
                  {{ getNombreAsesor(item) }}
               </template>

               <template #item.tipoBeneficioId="{ item }">
                  {{ getNombreBeneficio(item) }}
               </template>

               <template #item.opciones="{ item }">
                  <v-tooltip bottom max-width="300" color="primary">
                     <template #activator="{ on }">
                        <v-btn
                           text
                           small
                           fab
                           color="amber darken-3"
                           v-on="on"
                           @click="revisarSolicitud(item)"
                        >
                           <v-icon>fa-pen</v-icon>
                        </v-btn>
                     </template>
                     <span style="font-size: 15px"> Editar </span>
                  </v-tooltip>
               </template>
            </v-data-table>
            <!-- NUEVO: panel fijo para notificación -->
 <NotificacionPorCarnet
  v-if="puedeVerNotificacionesBeca"
  :ciclo="selectCiclo"
  @notificacion-enviada="listarSolicitudes()"
/>

      <!-- DASHBOARD SOLICITUDES DE BECA -->
      <DashboardSolicitudesBecas
        v-if="permController(23, 'ver')"
        class="mt-4"
        :solicitudes="solicitudes"
        :ciclo="selectCiclo"
        :loading="loadingSolicitudes"
        :asesores="cmbAsesores"
      />


         </v-card>
      </v-flex>
      <div class="text-center">
         <v-dialog v-model="logDialog" width="600">
            <v-card>
               <HistorialEstado :width="600" :estados="logs" />
               <v-divider></v-divider>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="logDialog = false">
                     Salir
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>
      </div>

   </v-layout>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import { mask } from 'vue-the-mask'
import { authComputed } from '../helpers'
import formatters from '../mixins/formattersLib'
import FormBecasDatosGenerales from './FormularioBecasDatosGenerales'
import FormBecasLaboral from './FormularioBecasLaboral'
import FormBecasNucleoFamiliar from './FormularioBecasNucleoFamiliar'
import FormBecasBienesFamiliares from './FormularioBecasBienesFamiliares'
import FormBecasContIngresosEgresos from './FormularioBecasContIngresosEgresos'
import FormBecasEnsayo from './FormularioBecasEnsayo'
import FormBecasComprobantes from './FormularioBecasComprobantes'
import ReportesSoliBeca from './custom/ReportesSoliBeca'
import XLSX from 'xlsx'
import HistorialEstado from '@/components/HistorialEstado.vue'
import * as ReportesBecas from '@/reportes/cartas-becas'
const getReporteLib = () => import('../mixins/reporteLib')
import NotificacionPorCarnet from "./ReenviarNotificacionesSolicitudesBecas/NotificacionPorCarnet.vue"
import ReaplicacionProgreso from './ReaplicacionProgreso.vue'
import DashboardSolicitudesBecas from './DashboardSolicitudesBecas.vue'
const RecordAlu = () => import('./RecordAlu')
const HistorialBecas = () => import('./custom/BecasAplicadas.vue')
const Pensum = () => import('./Pensum.vue')



export default {
   name: 'SolicitudesBecas',
   components: {
      NotificacionPorCarnet,
      FormBecasDatosGenerales,
      FormBecasLaboral,
      FormBecasNucleoFamiliar,
      FormBecasBienesFamiliares,
      FormBecasContIngresosEgresos,
      FormBecasEnsayo,
      FormBecasComprobantes,
      ReportesSoliBeca,
      HistorialEstado,
      RecordAlu,
      HistorialBecas,
      Pensum,
      ReaplicacionProgreso,
      DashboardSolicitudesBecas
   },
   directives: {
      mask
   },
   mixins: [formatters],
   data: () => ({
      dialogNotificacionCarnet: false,
      loadingSolicitudes: false,
      showFilterAsesor: false,
      showFilterBeneficio: false,
      showFilterBeneficiario: false,
      dialogRepIndividuales: false,
      dialogRepGrupales: false,
      dialogoBloquear: false,
      dialogReaplicacion: false,
      editedIndex: -1,
      radioResumenGeneral: 'r-nofiltrar',
      selectCarrera: null,
      selectFacultad: null,
      cmbCarrera: [],
      cmbFacultad: [],
      cicloActual: '',
      reaplicacionOutput: '',
      loadingReaplicacion: false,
      reaplicacionCarnet: '',
      swReaplicarCarnet: false,
      mostrandoProgreso: false,
      animandoResultados: false,
      listaReaplicacion: [],
      headers: [
         {
            text: 'N° Caso',
            value: 'solicitudBecaId',
            width: 120,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Comp.',
            value: 'completada',
            width: 100,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Noti.',
            value: 'notificado',
            width: 100,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Carnet',
            width: 130,
            value: 'carnet',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Nombres',
            value: 'nombres',
            class: 'titulo'
         },
         {
            text: 'Apellidos',
            value: 'apellidos',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Carrera',
            value: 'carreraUniversitaria',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Beneficiario',
            value: 'beneficiario',
            width: 150,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Fecha',
            value: 'createOn',
            align: 'center',
            class: 'titulo',
            sort: (a, b) => {
               var date1 = new Date(
                  a.split(' ')[0].replace(/(\d+)\/(\d+)\/(\d+)/, '$3/$2/$1')
               )
               var date2 = new Date(
                  b.split(' ')[0].replace(/(\d+)\/(\d+)\/(\d+)/, '$3/$2/$1')
               )

               return date1 < date2 ? -1 : 1
            }
         },
         {
            text: 'Asesor',
            value: 'asesorId',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Estado',
            value: 'estadoCaso',
            align: 'center',
            class: 'titulo',
            width: 100
         },
         {
            text: '',
            value: 'prioridad',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Opciones',
            value: 'opciones',
            width: 100,
            sortable: false,
            align: 'right',
            class: 'titulo'
         }
      ],

      // Variables de formularios
      search: '',
      numeroCaso: 0,
      numeroRef: '',
      carreraId: 0,
      solicitudes: [],
      soliSortBy: [],
      soliSortDesc: [],
      soliPage: 1,
      soliItemsPerPage: 25,
      verNuevo: false,
      modoPresentacion: false,
      slideData: {
         loadingSlide: false,
         laboral: [],
         nucleo: [],
         bienes: null,
         fotoVivienda: [],
         ingresos: [],
         egresos: [],
         ensayo: '',
         comprobantes: []
      },
      slideViewer: { show: false, url: '', nombre: '' },
      slideDescPopup: { show: false, text: '' },
      dialogSlideNotas: false,
      dialogSlideHistorialBecas: false,
      dialogSlidePensum: false,
      dialogSlideSolicitudes: false,
      slideSolicitudesSearch: '',
      loadingCargarSolicitud: false,
      vistasIds: [],
      dialogConfirmVista: false,
      itemPendienteSlide: null,
      slideFiltrosBeneficiario: null,
      slideFiltrosTipoBeneficio: null,
      slideSolicitudesList: [],
      loadingSlideSolicitudes: false,
      dialogSlideEstado: false,
      dialogSlideTipoBeca: false,
      slideEstadoId: null,
      slideTipoBecaId: null,
      loadingSlideEstado: false,
      loadingSlideTipoBeca: false,
      cmbEstadoCasoSlide: [],
      cmbTipoBecaSlide: [],
      slideToast: false,
      slideToastText: '',
      slideToastColor: 'success',
      snackbar: false,
      snackText: '',
      snackColor: 'primary',
      stepNum: 3,
      solicitudBecaId: null,
      solicitudBecaRef: null,
      solicitudBeneId: null,
      solicitudInfo: null,
      completada: false,
      carnet: '',
      selectBeneficiario: null,
      reenviando: false,
      reenviandoId: null,
      dialogReporteLoading: false,
      selectEsReaplicacion: null,
      cmbEsReaplicacion: [
         {
            id: null,
            nombre: 'Todas'
         },
         {
            id: false,
            nombre: 'Nuevo'
         },
         {
            id: true,
            nombre: 'Reaplicación'
         }
      ],

      // Propiedades formulario
      cmbCiclosBecas: [],
      radiosBusqueda: 'r-nombres',
      selectAsesor: '',
      selectBeneficiarioFiltro: '',
      cmbBeneficiario: [],
      selectTipoBeneficio: '',
      cmbTipoBeneficio: [],
      selectAsesorFilter: '',
      cmbAsesores: [],
      cmbUsuarios: [],
      selectCiclo: '',
      logs: [],
      logDialog: false
   }),
   computed: {
      ...authComputed,

      seccionesPresent() {
         const todas = [
            { step: 3,   nombre: 'Datos Generales' },
            { step: 3.1, nombre: 'Información Laboral' },
            { step: 3.2, nombre: 'Núcleo Familiar' },
            { step: 3.3, nombre: 'Bienes Familiares' },
            { step: 3.4, nombre: 'Ingresos y Egresos' },
            { step: 3.5, nombre: 'Ensayo' },
            { step: 4,   nombre: 'Comprobantes' }
         ]
         const beneId = this.solicitudBeneId
         return todas.filter(s => {
            if ([3.1, 3.2, 3.3, 3.4].includes(s.step) && ![1, 2, 4, 8, 9].includes(beneId)) return false
            if (s.step === 3.5 && ![1, 2, 8, 9].includes(beneId)) return false
            return true
         })
      },
      indexSeccionActual() {
         return this.seccionesPresent.findIndex(s => s.step === this.stepNum)
      },
      seccionActualNombre() {
         const s = this.seccionesPresent.find(s => s.step === this.stepNum)
         return s ? s.nombre : ''
      },
      totalIngresos() {
         return this.slideData.ingresos.reduce((s, r) => s + Number(r.monto || 0), 0).toFixed(2)
      },
      totalEgresos() {
         return this.slideData.egresos.reduce((s, r) => s + Number(r.monto || 0), 0).toFixed(2)
      },
      solicitudesFiltradas() {
         return this.slideSolicitudesList.filter(s => {
            if (this.slideFiltrosBeneficiario && s.beneficiarioId !== this.slideFiltrosBeneficiario) return false
            if (this.slideFiltrosTipoBeneficio && s.tipoBeneficioId !== this.slideFiltrosTipoBeneficio) return false
            return true
         })
      },

      puedeVerNotificacionesBeca() {
        return this.permController(19, 'ver') && this.checkRangoAlto()
      },
      puedeVerModoPresentacion() {
        return this.permController(22, 'ver') && this.checkRangoAlto()
      },
      filteredSolicitudes() {
         switch (this.radiosBusqueda) {
            case 'r-nombres':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.search ||
                     new RegExp(this.search, 'i').test(i.nombres)
                  )
               })
               break
            case 'r-carnet':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.search || new RegExp(this.search, 'i').test(i.carnet)
                  )
               })
               break
            case 'r-apellidos':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.search ||
                     new RegExp(this.search, 'i').test(i.apellidos)
                  )
               })
               break
            case 'r-fecha':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.search || new RegExp(this.search, 'i').test(i.fecha)
                  )
               })
               break
            case 'r-carrera':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.search ||
                     new RegExp(this.search, 'i').test(i.carreraUniversitaria)
                  )
               })
               break
            case 'r-estado':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.search ||
                     new RegExp(this.search, 'i').test(i.estadoCaso)
                  )
               })
               break
            case 'r-asesor':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.selectAsesorFilter ||
                     this.selectAsesorFilter == i.asesorId
                  )
               })
               break
            case 'r-beneficiario':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.selectBeneficiarioFiltro ||
                     this.selectBeneficiarioFiltro == i.beneficiarioId
                  )
               })
               break
            case 'r-tipobeneficio':
               return this.solicitudes.filter((i) => {
                  return (
                     !this.selectTipoBeneficio ||
                     this.selectTipoBeneficio == i.tipoBeneficioId
                  )
               })
               break
            default:
               return this.solicitudes
         }
      },
      searchComputed: {
         get() {
            return this.search
         },
         set: debounce(function (newVal) {
            this.search = newVal.trim()
         }, 500)
      }
   },
   watch: {
      modoPresentacion(val) {
         if (val) this.fetchSlideData(this.stepNum)
      },
      stepNum(val) {
         if (this.modoPresentacion) this.fetchSlideData(val)
      },
      dialogSlideSolicitudes(val) {
         if (val) {
            if (this.oidcUser) {
               axios
                  .get(`api/SolicitudBecaVista?userId=${this.oidcUser.sub}`)
                  .then(r => { this.vistasIds = r.data })
                  .catch(() => {})
            }
            this.cargarSolicitudesSlide()
         }
      },
      dialogSlideNotas(val) {
         if (val) {
            this.$nextTick(() => {
               window.dispatchEvent(new Event('resize'))
            })
         }
      },
      dialogSlidePensum(val) {
         if (val) {
            this.$nextTick(() => {
               if (this.$refs.pensumSlide) this.$refs.pensumSlide.ajustarEscala()
            })
         }
      },
      swReaplicarCarnet(val) {
         if (val == false) {
            this.reaplicacionCarnet = ''
         }
      },
      selectCiclo() {
         this.listarSolicitudes()
      },
      selectEsReaplicacion() {
         this.listarSolicitudes()
      },
      radioResumenGeneral() {
         this.selectCarrera = null
         this.selectFacultad = null
      },
      dialogRepGrupales() {
         this.radioResumenGeneral = 'r-nofiltrar'
      }
   },
   created() {
      // Validando acceso al componente
      if (this.permController(9, 'ver')) {
         this.listarComboboxes()
      } else {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      async iniciarAnimacion(resultados) {
         this.listaReaplicacion = []
         this.animandoResultados = true
         for (const item of resultados) {
            this.listaReaplicacion.push(item)
            await new Promise(r => setTimeout(r, 80))
         }
         this.animandoResultados = false
      },
      reaplicarCarnet() {
         this.loadingReaplicacion = true
         this.mostrandoProgreso = true
         const t0 = performance.now()
         axios
            .post('api/SolicitudDeBeca/Reapliacion', {
               cicloOrigen: this.selectCiclo,
               cicloDestino: this.cicloActual,
               carnet: this.reaplicacionCarnet
            }, { timeout: 1200000 })
            .then(async (response) => {
               const totalFrontend = Math.round(performance.now() - t0)
               const backendStr = response.headers['x-timing'] ? ' | Backend: ' + response.headers['x-timing'] : ''
               console.log(`[PERF] Reaplicacion (carnet) => Frontend_ms=${totalFrontend}${backendStr}`)
               this.loadingReaplicacion = false
               const res = response.data
               if (res.length > 0) await this.iniciarAnimacion(res)
            })
            .catch(() => {
               this.loadingReaplicacion = false
               this.mostrandoProgreso = false
            })
      },
      reaplicarCiclo() {
         this.loadingReaplicacion = true
         this.mostrandoProgreso = true
         const t0 = performance.now()
         axios
            .post('api/SolicitudDeBeca/Reapliacion', {
               cicloOrigen: this.selectCiclo,
               cicloDestino: this.cicloActual
            }, { timeout: 1200000 })
            .then(async (response) => {
               const totalFrontend = Math.round(performance.now() - t0)
               const backendStr = response.headers['x-timing'] ? ' | Backend: ' + response.headers['x-timing'] : ''
               console.log(`[PERF] Reaplicacion (ciclo) => Frontend_ms=${totalFrontend}${backendStr}`)
               this.loadingReaplicacion = false
               const res = response.data
               if (res.length > 0) await this.iniciarAnimacion(res)
            })
            .catch(() => {
               this.loadingReaplicacion = false
               this.mostrandoProgreso = false
            })
      },
      showDialogReaplicacion() {
         this.dialogReaplicacion = true
      },
      closeDialogReaplicacion() {
         this.reaplicacionOutput = ''
         this.swReaplicarCarnet = false
         this.mostrandoProgreso = false
         this.animandoResultados = false
         this.listaReaplicacion = []
         this.dialogReaplicacion = false
      },
      reporteResumenGeneral(carreraId = null, facultadId = null) {
         this.dialogReporteLoading = true
         var resPago = []
         var queryResult =
            'api/SolicitudDeBeca/Resumen?PeriodoLectivo=' + this.selectCiclo

         if (carreraId != null && facultadId == null) {
            queryResult = queryResult.concat('&CarreraId=' + this.selectCarrera)
         }
         if (carreraId == null && facultadId != null) {
            queryResult = queryResult.concat(
               '&FacultadId=' + this.selectFacultad
            )
         }

         axios
            .get(queryResult)
            .then((response) => {
               resPago = response.data
            })
            .catch((error) => {
               console.log(error)
               this.dialogReporteLoading = false
            })
            .finally(() => {
               // Generar excel
               var heading = [
                  [
                     'Nombre',
                     'Carnet',
                     'N° de aplicaciones',
                     'N° de ciclos de ser becario',
                     'Facultad',
                     'Carrera',
                     'Ciclo',
                     'Dirección',
                     'N° de miembros en familia',
                     'Salario',
                     'Otros ingresos',
                     'Energía eléctrica',
                     'Agua',
                     'Teléfono / Internet',
                     'Vivienda',
                     'Otros egresos',
                     'Total ingresos',
                     'Total egresos',
                     'Observaciones asesor',
                     'Observaciones administrador',
                     'Estado',
                     'CUM'
                  ]
               ]

               var today = new Date()
               //today = today.substring(0, 16)
               var filename = 'Resumen general ' + today + '.xlsx'
               var wb = XLSX.utils.book_new()

               // Agregando headers y data de arreglo
               var ws = XLSX.utils.aoa_to_sheet(heading, { origin: 'A1' })
               XLSX.utils.sheet_add_json(ws, resPago, {
                  skipHeader: true,
                  origin: 'A2'
               })
               XLSX.utils.sheet_add_aoa(ws, [['Ingresos']], {
                  origin: 'J1'
               })
               XLSX.utils.sheet_add_aoa(ws, [['Egresos']], {
                  origin: 'L1'
               })

               // Get worksheet range
               var range = XLSX.utils.decode_range(ws['!ref'])

               for (var R = range.s.r; R <= range.e.r; ++R) {
                  for (var C = 7; C <= 19; C++) {
                     if (R >= 2 && (C == 7 || C == 18 || C == 19)) {
                        var cell_address = { c: C, r: R }
                        var cell_ref = XLSX.utils.encode_cell(cell_address)

                        // Cambiando valor actual por comentario
                        var oldValue = ws[cell_ref].v
                        if (oldValue == null || oldValue.trim() == '') {
                           ws[cell_ref].v = ''
                        } else {
                           ws[cell_ref].v =
                              C == 7 ? 'Ver dirección' : 'Ver comentario'
                           ws[cell_ref].c = []
                           ws[cell_ref].c.hidden = true
                           ws[cell_ref].c.push({
                              a: 'Sistema',
                              t: oldValue
                           })
                        }
                     }
                  }
               }

               /* Testing comment
               ws['A4'].c = []
               ws['A4'].c.hidden = true
               ws['A4'].c.push({ a: 'SheetJS', t: 'This comment is hidden' }) */

               const merge = [
                  { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
                  { s: { r: 0, c: 11 }, e: { r: 0, c: 15 } }
               ]
               ws['!merges'] = merge

               // Asignando ancho de columnas segun contenido
               resPago.forEach((el) => {
                  el.observacionAsesor = 'Ver comentario'
                  el.observacionAdministrador = 'Ver comentario'
                  el.ciudadDeProcedencia = 'Ver direccion'
               })
               this.autofitColumns(resPago, ws)

               // Agregando hoja y exportando archivo
               XLSX.utils.book_append_sheet(wb, ws, 'Reporte')
               XLSX.writeFile(wb, filename)
               this.dialogReporteLoading = false
            })
      },
      reporteExcelSolicitudes() {
         this.dialogReporteLoading = true
         var resPago = []

         axios
            .get(
               'api/SolicitudDeBeca/reporte?cicloDeAplicacion=' +
                  this.selectCiclo
            )
            .then((response) => {
               resPago = response.data
            })
            .catch((error) => {
               console.log(error)
               this.dialogReporteLoading = false
            })
            .finally(() => {
               // Generar excel
               var heading = [
                  [
                     'N° Caso',
                     'Carnet',
                     'Nombre',
                     'Periodo Lectivo',
                     'Categoria',
                     'Descripcion',
                     'Carrera',
                     'Beneficiario',
                     'Reaplicacion',
                     'Estado',
                     'Correo',
                     'Telefono Principal',
                     'Telefono Secundario',
                     'BienestarUniversitario',
                     'CUM',
                     'Congregacion',
                     'Institucion Patrocinadora'
                  ]
               ]
               var today = new Date()
               //today = today.substring(0, 16)
               var filename = 'Solicitudes de beca ' + today + '.xlsx'
               var wb = XLSX.utils.book_new()

               // Agregando headers y data de arreglo
               var ws = XLSX.utils.aoa_to_sheet(heading, { origin: 'A1' })
               XLSX.utils.sheet_add_json(ws, resPago, {
                  skipHeader: true,
                  origin: 'A2'
               })

               // Asignando ancho de columnas segun contenido
               this.autofitColumns(resPago, ws)

               // Agregando hoja y exportando archivo
               XLSX.utils.book_append_sheet(wb, ws, 'Reporte')
               XLSX.writeFile(wb, filename)
               this.dialogReporteLoading = false
            })
      },
      reenviarSolicitud(item) {
         this.reenviando = true
         this.reenviandoId = item.solicitudBecaId
         axios
            .post(
               'api/SolicitudDeBeca/ReenviarNotificacion/' +
                  item.solicitudBecaId
            )
            .then(() => {
               this.snackText = `Notificación reenviada a ${item.email}!`
               this.snackColor = 'snackSuccess'
               this.snackbar = true
               setTimeout(() => {
                  this.reenviando = false
                  this.reenviandoId = null
                  this.listarSolicitudes()
               }, 500)
            })
            .catch(() => {
               this.snackText =
                  'No fue posible reenviar la notificación, por favor intente de nuevo en unos minutos.'
               this.snackColor = 'snackError'
               this.snackbar = true
               this.reenviando = false
               this.reenviandoId = null
            })
      },
      alternarCompletado(item) {
         axios
            .put('api/SolicitudDeBeca/completar/' + item.solicitudBecaId, {
               completar: !item.completada
            })
            .then(() => {
               this.snackText = 'Estado de completado actualizado'
               this.snackColor = 'snackSuccess'
               this.snackbar = true
               setTimeout(() => {
                  this.listarSolicitudes()
               }, 500)
            })
            .catch(() => {
               this.snackText = 'Error al actualizar estado de completado'
               this.snackColor = 'snackError'
               this.snackbar = true
            })
      },
      esImagen(url) {
         return /\.(jpg|jpeg|png|bmp|gif|webp)$/i.test(url || '')
      },
      abrirVisor(c) {
         this.slideViewer = { show: true, url: c.path, nombre: c.comprobante }
      },
      verDescripcionCompleta(text) {
         this.slideDescPopup = { show: true, text }
      },
      etiquetaFotoVivienda(tipo) {
         const etiquetas = { FRENTE: 'Frente', INTERIOR_1: 'Interior 1', INTERIOR_2: 'Interior 2', INTERIOR_3: 'Interior 3' }
         return etiquetas[tipo] || tipo
      },
      normalizarRuta(path) {
         if (!path) return ''
         if (path.startsWith('blob:') || path.startsWith('http')) return path
         const limpia = path.replace(/\\/g, '/')
         const base = (process.env.VUE_APP_API || '').replace(/\/$/, '')
         const ruta = limpia.startsWith('/') ? limpia.slice(1) : limpia
         return `${base}/${ruta}`
      },
      getNombreCarrera(id) {
         const c = (this.cmbCarrera || []).find(x => x.carreraUniversitariaId == id)
         return c ? c.nombre : '—'
      },
      getNombreBeneficiario(id) {
         const b = (this.cmbBeneficiario || []).find(x => x.beneficiarioId == id)
         return b ? b.nombre : '—'
      },
      getNombreAsesor(id) {
         const a = (this.cmbAsesores || []).find(x => x.id == id)
         return a && a.userClaims && a.userClaims[0] ? a.userClaims[0].claimValue : '—'
      },
      toggleVista(item) {
         if (!this.oidcUser) return
         const userId = this.oidcUser.sub
         const id = item.solicitudBecaId
         const yaVista = this.vistasIds.includes(id)
         if (yaVista) {
            axios.delete(`api/SolicitudBecaVista/${id}?userId=${userId}`)
               .then(() => { this.vistasIds = this.vistasIds.filter(v => v !== id) })
               .catch(() => {})
         } else {
            axios.post('api/SolicitudBecaVista', { solicitudBecaId: id, userId })
               .then(() => { this.vistasIds.push(id) })
               .catch(() => {})
         }
      },
      cargarSolicitudesSlide() {
         this.loadingSlideSolicitudes = true
         const url = this.checkRangoAlto()
            ? `api/SolicitudDeBeca?CicloDeAplicacion=${this.selectCiclo}`
            : `api/SolicitudDeBeca?AsesorId=${this.oidcUser.sub}&CicloDeAplicacion=${this.selectCiclo}`
         axios.get(url)
            .then(r => { this.slideSolicitudesList = r.data })
            .catch(() => { this.showSlideToast('Error al cargar solicitudes.', 'error') })
            .finally(() => { this.loadingSlideSolicitudes = false })
      },
      cargarSolicitudEnSlide(item) {
         this.itemPendienteSlide = item
         this.dialogConfirmVista = true
      },
      confirmarAbrirConVista() {
         this.dialogConfirmVista = false
         const item = this.itemPendienteSlide
         if (!item) return
         if (this.oidcUser && !this.vistasIds.includes(item.solicitudBecaId)) {
            const userId = this.oidcUser.sub
            axios.post('api/SolicitudBecaVista', { solicitudBecaId: item.solicitudBecaId, userId })
               .then(() => { this.vistasIds.push(item.solicitudBecaId) })
         }
         this._ejecutarCargarSolicitud(item)
      },
      confirmarAbrirSinVista() {
         this.dialogConfirmVista = false
         this._ejecutarCargarSolicitud(this.itemPendienteSlide)
      },
      _ejecutarCargarSolicitud(item) {
         if (!item) return
         this.loadingCargarSolicitud = true
         axios
            .get('api/SolicitudDeBeca?numeroRef=' + item.numeroReferencia)
            .then((response) => {
               if (!response.data.length) return
               const info = response.data[0]
               this.solicitudInfo    = info
               this.solicitudBecaId  = info.solicitudBecaId
               this.solicitudBecaRef = info.numeroReferencia
               this.solicitudBeneId  = info.beneficiarioId
               this.selectBeneficiario = info.beneficiarioId
               this.completada       = info.completada
               this.numeroCaso       = info.solicitudBecaId
               this.numeroRef        = info.numeroReferencia
               this.carreraId        = info.carreraUniversitariaId
               this.stepNum          = 3
               this.dialogSlideSolicitudes = false
               this.$nextTick(() => this.fetchSlideData(3))
            })
            .catch(() => { this.showSlideToast('Error al cargar la solicitud.', 'error') })
            .finally(() => { this.loadingCargarSolicitud = false })
      },
      showSlideToast(text, color = 'success') {
         this.slideToastText = text
         this.slideToastColor = color
         this.slideToast = true
         setTimeout(() => { this.slideToast = false }, 3000)
      },
      getTipoBecaNombre(id) {
         if (!id || id === 1) return '—'
         const tipo = this.cmbTipoBecaSlide.find(t => t.tipoBecaId === id)
         return tipo ? tipo.descripcion : '—'
      },
      abrirDialogSlideEstado() {
         this.slideEstadoId = this.solicitudInfo ? this.solicitudInfo.estadoCasoId : null
         this.dialogSlideEstado = true
      },
      abrirDialogSlideTipoBeca() {
         this.slideTipoBecaId = this.solicitudInfo ? this.solicitudInfo.tipoBecaId : null
         this.dialogSlideTipoBeca = true
      },
      guardarEstadoSlide() {
         if (!this.slideEstadoId) return
         this.loadingSlideEstado = true
         axios
            .put(`api/SolicitudDeBeca/estado/${this.solicitudBecaId}`, { estadoId: this.slideEstadoId })
            .then(() => {
               const estado = this.cmbEstadoCasoSlide.find(e => e.estadoCasoId === this.slideEstadoId)
               if (estado && this.solicitudInfo) {
                  this.solicitudInfo.estadoCasoId = estado.estadoCasoId
                  this.solicitudInfo.estadoCaso = estado.nombre
               }
               this.dialogSlideEstado = false
               this.showSlideToast('Estado actualizado correctamente.')
            })
            .catch(() => { this.showSlideToast('Error al actualizar el estado.', 'error') })
            .finally(() => { this.loadingSlideEstado = false })
      },
      guardarTipoBecaSlide() {
         if (!this.slideTipoBecaId) return
         this.loadingSlideTipoBeca = true
         axios
            .put(`api/SolicitudDeBeca/tipobeca/${this.solicitudBecaId}`, { tipoBecaId: this.slideTipoBecaId })
            .then(() => {
               if (this.solicitudInfo) {
                  this.solicitudInfo.tipoBecaId = this.slideTipoBecaId
               }
               this.dialogSlideTipoBeca = false
               this.showSlideToast('Tipo de beca actualizado correctamente.')
            })
            .catch(() => { this.showSlideToast('Error al actualizar el tipo de beca.', 'error') })
            .finally(() => { this.loadingSlideTipoBeca = false })
      },
      refreshSlideData() {
         if (this.stepNum == 3) {
            this.slideData.loadingSlide = true
            axios.get(`api/SolicitudDeBeca?numeroRef=${this.solicitudBecaRef}`)
               .then(r => { if (r.data.length > 0) this.solicitudInfo = r.data[0] })
               .finally(() => { this.slideData.loadingSlide = false })
         } else {
            this.fetchSlideData(this.stepNum)
         }
      },
      fetchSlideData(step) {
         const id = this.solicitudBecaId
         if (!id) return
         this.slideData.loadingSlide = true
         const done = () => { this.slideData.loadingSlide = false }

         if (step == 3.1) {
            axios.get(`api/solicitudesdebecas/${id}/DatoLaboralFamiliar`)
               .then(r => { this.slideData.laboral = r.data || [] })
               .finally(done)
         } else if (step == 3.2) {
            axios.get(`api/solicitudesdebecas/${id}/NucleoFamiliar`)
               .then(r => { this.slideData.nucleo = r.data || [] })
               .finally(done)
         } else if (step == 3.3) {
            Promise.all([
               axios.get(`api/solicitudesdebecas/${id}/BienesFamiliares`),
               axios.get(`api/solicitudesdebecas/${id}/FotoVivienda`)
            ]).then(([rb, rf]) => {
               this.slideData.bienes = rb.data
               this.slideData.fotoVivienda = (rf.data || []).filter(f => f.fotoPath)
            }).finally(done)
         } else if (step == 3.4) {
            Promise.all([
               axios.get(`api/solicitudesdebecas/${id}/SolicitudIngreso`),
               axios.get(`api/solicitudesdebecas/${id}/SolicitudEgreso`)
            ]).then(([ri, re]) => {
               this.slideData.ingresos = ri.data || []
               this.slideData.egresos  = (re.data || []).filter(r => Number(r.egresoId) !== 10)
            }).finally(done)
         } else if (step == 3.5) {
            axios.get(`api/SolicitudDeBeca/${id}`)
               .then(r => { this.slideData.ensayo = r.data.ensayo || '' })
               .finally(done)
         } else if (step == 4) {
            axios.get(`api/solicitudesdebecas/${id}/PathComprobante`)
               .then(r => {
                  this.slideData.comprobantes = (r.data || []).filter(x => x.path != null)
               })
               .finally(done)
         } else {
            done()
         }
      },
      regresar() {
         this.verNuevo = false
         this.modoPresentacion = false
         this.solicitudBecaId = null
         this.listarSolicitudes()
      },
      nextStepDatosGenerales(soliInfo) {
         this.solicitudBecaId = soliInfo.solicitudBecaId
         this.selectBeneficiario = soliInfo.beneficiarioId
         this.completada = soliInfo.completada
         this.solicitudInfo = soliInfo

         // Si ya esta cargada una solicitud, solo pasar al siguiente step
         if (
            soliInfo.beneficiarioId == 1 ||
            soliInfo.beneficiarioId == 2 ||
            soliInfo.beneficiarioId == 4 ||
            soliInfo.beneficiarioId == 8 ||
            soliInfo.beneficiarioId == 9
         ) {
            this.stepNum = 3.1
         } else {
            this.stepNum = 4
         }
      },
      revisarSolicitud(item) {
         // Campos para dialogo de reportes
         this.numeroCaso = item.solicitudBecaId
         this.numeroRef = item.numeroReferencia
         this.carreraId = item.carreraUniversitariaId
         this.completada = item.completada
         this.selectBeneficiario = item.beneficiarioId

         // Consultando informacion de solicitud
         this.solicitudBeneId = null
         axios
            .get('api/SolicitudDeBeca?numeroRef=' + item.numeroReferencia)
            .then((response) => {
               this.stepNum = 3
               this.verNuevo = true
               this.$nextTick(() => {
                  this.solicitudInfo = response.data[0]
                  this.solicitudBecaId = this.solicitudInfo.solicitudBecaId
                  this.solicitudBecaRef = this.solicitudInfo.numeroReferencia
                  this.solicitudBeneId = this.solicitudInfo.beneficiarioId
               })
            })

         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },
      getLog(item) {
         axios
            .get('/api/SolicitudBecaLog/' + item.numeroReferencia)
            .then((response) => {
               this.logs = response.data
               this.logDialog = true
            })
      },
      footerByUser(user) {
         if (
            user.nivelasesor == 0 ||
            user.nivelasesor > 1 ||
            user.role == 'admin'
         ) {
            return {
               itemsPerPageOptions: [25, 50, 75],
               itemsPerPageText: 'Filas por página:'
            }
         } else {
            return {
               itemsPerPageOptions: [10, 25],
               itemsPerPageText: 'Filas por página:'
            }
         }
      },
      cambiaRadios() {
         if (this.radiosBusqueda == 'r-asesor') {
            this.showFilterAsesor = true
            this.showFilterBeneficio = false
            this.showFilterBeneficiario = false
            this.selectAsesorFilter = ''
            this.search = ''
         } else if (this.radiosBusqueda == 'r-tipobeneficio') {
            this.showFilterAsesor = false
            this.showFilterBeneficio = true
            this.showFilterBeneficiario = false
            this.selectTipoBeneficio = ''
            this.search = ''
         } else if (this.radiosBusqueda == 'r-beneficiario') {
            this.showFilterAsesor = false
            this.showFilterBeneficio = false
            this.showFilterBeneficiario = true
            this.selectBeneficiarioFiltro = ''
            this.search = ''
         } else {
            this.showFilterAsesor = false
            this.showFilterBeneficio = false
            this.showFilterBeneficiario = false
            this.selectAsesorFilter = ''
            this.selectTipoBeneficio = ''
            setTimeout(() => {
               this.focusBusqueda()
            }, 300)
         }
      },
      checkRangoAlto() {
         if (this.oidcUser) {
            return Number(this.oidcUser.nivelasesor) > 1 ||
               Number(this.oidcUser.nivelasesor) == 0 ||
               this.oidcUser.role == 'admin'
               ? true
               : false
         } else {
            return false
         }
      },
      checkModificarAsesor() {
         if (this.oidcUser !== null) {
            return this.oidcUser.role === 'admin' ||
               this.oidcUser.nivelasesor === '0'
               ? true
               : false
         } else {
            return false
         }
      },

      getNombreAsesor(item) {
         if (item != undefined && this.cmbUsuarios.length > 0) {
            return this.cmbUsuarios.find((obj) => {
               return obj.id === item.asesorId
            })
               ? this.cmbUsuarios.find((obj) => {
                    return obj.id === item.asesorId
                 }).userClaims[0].claimValue
               : 'Administrador'
         }
      },
      getNombreBeneficio(item) {
         if (item != undefined && this.cmbTipoBeneficio.length > 0) {
            return this.cmbTipoBeneficio.find((obj) => {
               return obj.tipoBeneficioId === item.tipoBeneficioId
            })
               ? this.cmbTipoBeneficio.find((obj) => {
                    return obj.tipoBeneficioId === item.tipoBeneficioId
                 }).nombre
               : ''
         }
      },
      // Autoseleccionar la busqueda al cambiar filtro de busquedad
      focusBusqueda() {
         this.$refs.txtBusqueda.focus()
      },
      // Popular el datatable
      listarSolicitudes() {
         this.loadingSolicitudes = true
         // Listar todos las solicitudes solo si es admin o nivel 2
         if (this.checkRangoAlto()) {
            var filtroString =
               this.selectEsReaplicacion == null
                  ? ''
                  : '&Reapliacion=' + this.selectEsReaplicacion
            axios
               .get(
                  'api/SolicitudDeBeca?CicloDeAplicacion=' +
                     this.selectCiclo +
                     filtroString
               )
               .then((response) => {
                  this.solicitudes = response.data
               })
               .catch(() => {
                  //console.log(error)
               })
               .finally(() => {
                  this.loadingSolicitudes = false
               })
         } else {
            axios
               .get(
                  'api/SolicitudDeBeca?AsesorId=' +
                     this.oidcUser.sub +
                     '&CicloDeAplicacion=' +
                     this.selectCiclo
               )
               .then((response) => {
                  this.solicitudes = response.data
               })
               .catch(() => {
                  //console.log(error)
               })
               .finally(() => {
                  this.loadingSolicitudes = false
               })
         }
      },
      listarComboboxes() {
         axios
            .get('api/Configuracion/cicloActual')
            .then((response) => {
               this.cicloActual = response.data.valor
            })
            .catch(() => {
               //console.log(error)
            })
         axios
            .get('api/SolicitudDeBeca/ciclosDisponibles')
            .then((response) => {
               this.cmbCiclosBecas = response.data
               this.selectCiclo = response.data[response.data.length - 1]
            })
            .catch(() => {
               //console.log(error)
            })
         axios
            .get('api/general/CarreraUniversitaria')
            .then((response) => {
               this.cmbCarrera = response.data
            })
            .catch(() => {
               //console.log(error)
            })
         axios
            .get('api/general/UnidadAcademica')
            .then((response) => {
               this.cmbFacultad = response.data
            })
            .catch(() => {
               //console.log(error)
            })
         axios
            .get('api/solicitudesdebecas/Beneficiario')
            .then((response) => {
               this.cmbBeneficiario = response.data
            })
            .catch(() => {
               //console.log(error)
            })
         axios({
            method: 'get',
            url: 'api/UserManagement/clienteweb?soloAsesores=true',
            baseURL: process.env.VUE_APP_IDENTITY
         }).then((response) => {
            this.cmbAsesores = response.data
            //console.log(me.usuarios)
         })
         axios({
            method: 'get',
            url: 'api/UserManagement/clienteweb',
            baseURL: process.env.VUE_APP_IDENTITY
         }).then((response) => {
            this.cmbUsuarios = response.data
            //console.log(me.usuarios)
         })
         axios
            .get('api/Beca/TipoBeneficio')
            .then((response) => {
               this.cmbTipoBeneficio = response.data.map((beneficio) => {
                  return {
                     tipoBeneficioId: beneficio.id,
                     nombre: beneficio.nombre
                  }
               })
            })
            .catch((error) => console.log(error))
         axios
            .get('api/EstadoCaso?parabecas=true')
            .then((response) => { this.cmbEstadoCasoSlide = response.data })
            .catch(() => {})
         axios
            .get('api/TipoBeca')
            .then((response) => { this.cmbTipoBecaSlide = response.data })
            .catch(() => {})
      },
      // Si no cargaron bien las solicitudes en el datatable se puede resetear
      reset() {
         this.listarSolicitudes()
      },
      getColorEstadoSoli(item) {
         switch (item.estadoCasoId) {
            case 1:
               return 'blue'
               break
            case 2:
               return 'amber darken-2'
               break
            case 3:
               return 'green'
               break
            case 4:
               return 'red darken-3'
               break
            case 5:
               return 'grey darken-3'
               break
            case 8:
               return 'teal'
               break
            case 9:
               return 'brown darken-1'
               break
            case 10:
               return 'lime darken-2'
               break
            default:
               return 'grey darken-1'
               break
         }
      },
      bloquearbecas() {
         this.dialogoBloquear = false
         console.log(this.selectCiclo)
         axios
            .put(
               `/api/SolicitudDeBeca/BloqueoTotal?bloquear=true&cicloDeAplicacion= ${this.selectCiclo}`
            )
            .then((response) => {
               console.log(response.status)
               if (response.status === 200) {
                  this.snackText = `Las solicitudes han sido bloqueadas exitosamente`
                  this.snackColor = 'snackSuccess'
                  this.snackbar = true

                  setTimeout(() => {
                     this.snackbar = false
                  }, 5000)
               }
            })
            .catch(() => {
               this.snackText = `Las solicitudes se encuentran bloqueadas`
               this.snackColor = 'snackError'
               this.snackbar = true

               setTimeout(() => {
                  this.snackbar = false
               }, 5000)
            })
      },
      generarCartasBecarios() {
         axios
            .get('api/Beca/Reportes/Cartas?periodoLectivo=' + this.selectCiclo)
            .then((response) => {
               let cartas = response.data
               if (cartas.length === 0) {
                  this.snackText = 'No hay becas aplicadas'
                  this.snackColor = 'snackSuccess'
                  this.snackbar = true
                  setTimeout(() => {
                     this.snackbar = false
                  }, 5000)
                  return
               }
               let content = []
               cartas.forEach((carta) => {
                  if (
                     carta.tipoBeneficio === 'Administrativo' &&
                     carta.esPostGrado === true &&
                     carta.reaplicacion === true
                  ) {
                     content.push(
                        ReportesBecas.dictamenAdminNuevaPostgrado(carta)
                     )
                  } else if (
                     carta.tipoBeneficio === 'Administrativo' &&
                     carta.reaplicacion === false
                  ) {
                     content.push(ReportesBecas.dictamenAdminNueva(carta))
                  } else if (
                     carta.tipoBeneficio === 'Administrativo' &&
                     carta.reaplicacion === true
                  ) {
                     content.push(ReportesBecas.dictamenAdminRenovacion(carta))
                  } else if (
                     carta.tipoBeneficio === 'Servicio Estudiantil' &&
                     carta.estadoCaso === 'Denegado'
                  ) {
                     content.push(
                        ReportesBecas.dictamenServicioEstudiantilDenegada(carta)
                     )
                  } else if (
                     carta.tipoBeneficio === 'Servicio Estudiantil' &&
                     carta.reaplicacion === false
                  ) {
                     content.push(
                        ReportesBecas.dictamenServicioEstudiantilNueva(carta)
                     )
                  } else if (
                     carta.tipoBeneficio === 'Servicio Estudiantil' &&
                     carta.reaplicacion === true
                  ) {
                     content.push(
                        ReportesBecas.dictamenServicioEstudiantilrenovacion(
                           carta
                        )
                     )
                  }
               })

               let dd = {
                  pageSize: 'LETTER',
                  content: content,
                  styles: {
                     headerMain: {
                        fontSize: 13,
                        bold: true,
                        margin: [30, 15]
                     },
                     header: {
                        fontSize: 13,
                        bold: true,
                        margin: [30, 40]
                     },
                     texto: {
                        alignment: 'justify',
                        fontSize: 10,
                        margin: [0, 20],
                        bold: false
                     },
                     subheader: {
                        fontSize: 12,
                        bold: true,
                        margin: [0, -4]
                     },
                     subheader1: {
                        fontSize: 12,
                        bold: true,
                        margin: [0, -15]
                     },
                     subheader3: {
                        fontSize: 12,
                        bold: true,
                        margin: [0, 10]
                     },
                     infoAlum: {
                        fontSize: 12,
                        bold: true,
                        margin: [0, 2]
                     },
                     infoAlumno: {
                        fontSize: 11,
                        bold: true,
                        margin: [0, 1]
                     },
                     espaciado: {
                        margin: [0, 50]
                     },
                     final: {
                        fontSize: 9
                     },
                     footer: {
                        fontSize: 9,
                        margin: [0, 25, 0, 0]
                     },
                     footer1: {
                        fontSize: 9,
                        margin: [0, 0, 0, 0]
                     },
                     tableExample: {
                        margin: [175, 50, 1, 40],
                        fontSize: 9
                     }
                  },
                  defaultStyle: {
                     columnGap: 20
                  }
               }
               var filename = 'Cartas.pdf'
               getReporteLib().then((res) =>
                  res.generarPDF('open', dd, filename)
               )
            })
      }
   }
}
</script>

<style scoped>
/* ══ OVERLAY ══ */
.presentation-overlay {
   position: fixed;
   top: 0; left: 0;
   width: 100vw; height: 100vh;
   background: #f5f5f5;
   z-index: 9999;
   display: flex;
   flex-direction: column;
}

/* ── Header ── */
.presentation-header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   background: #A00402;
   color: white;
   padding: 10px 24px;
   flex-shrink: 0;
}
.presentation-title {
   font-size: 18px;
   font-weight: 700;
   display: flex;
   align-items: center;
}
.presentation-counter {
   font-size: 14px;
   font-weight: 600;
   background: rgba(255,255,255,0.25);
   padding: 3px 16px;
   border-radius: 20px;
}

/* ── Contenido (sin scroll) ── */
.presentation-content {
   flex: 1;
   overflow: hidden;
   display: flex;
   flex-direction: column;
   position: relative;
}

.slide-page {
   flex: 1;
   display: flex;
   flex-direction: column;
   height: 100%;
}

/* ── Animación: slide horizontal suave ── */
.page-flip-leave-active {
   transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease;
   position: absolute;
   width: 100%;
}
.page-flip-leave-to {
   transform: translateX(-40px);
   opacity: 0;
}
.page-flip-enter-active {
   transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease;
}
.page-flip-enter {
   transform: translateX(40px);
   opacity: 0;
}
.page-flip-enter-to {
   transform: translateX(0);
   opacity: 1;
}

/* ── Nav inferior ── */
.presentation-nav {
   display: flex;
   align-items: stretch;
   background: #7a0200;
   flex-shrink: 0;
   overflow: hidden;
}

/* Botón de sección */
.nav-sec-btn {
   flex: 1;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 8px 6px;
   border: none;
   background: transparent;
   color: rgba(255,255,255,0.6);
   cursor: pointer;
   transition: background 0.2s, color 0.2s;
   border-right: 1px solid rgba(255,255,255,0.1);
   gap: 2px;
}
.nav-sec-btn:last-child { border-right: none; }
.nav-sec-btn:hover { background: rgba(255,255,255,0.1); color: #fff; }
.nav-sec-btn--active {
   background: rgba(255,255,255,0.18);
   color: #fff;
   border-top: 3px solid #deab2f;
}
.nav-sec-num {
   font-size: 11px;
   font-weight: 700;
   line-height: 1;
}
.nav-sec-label {
   font-size: 11px;
   font-weight: 500;
   line-height: 1.2;
   text-align: center;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   max-width: 100%;
}

/* ══ SLIDE BODY ══ */
.slide-body {
   flex: 1;
   overflow: hidden;
   padding: 12px 24px;
   display: flex;
   flex-direction: column;
   gap: 12px;
}
.slide-center {
   align-items: center;
   justify-content: center;
   text-align: center;
}

/* ── Sección superior (avatar + grid) ── */
.slide-section {
   display: flex;
   align-items: flex-start;
   gap: 24px;
   flex: 1;
   min-height: 0;
}
.slide-avatar-block {
   display: flex;
   flex-direction: column;
   align-items: center;
   flex-shrink: 0;
   min-width: 110px;
}
.slide-carnet {
   font-size: 13px;
   font-weight: 700;
   color: #A00402;
   letter-spacing: 1px;
}
.slide-avatar-actions {
   display: flex;
   flex-direction: column;
   gap: 5px;
   width: 100%;
}
.slide-action-btn {
   display: flex;
   align-items: center;
   gap: 6px;
   background: #FFFFFF;
   border: 2px solid #C6AB55;
   color: #6C1C19;
   border: 1px solid #c99a20;
   border-radius: 6px;
   padding: 4px 8px;
   cursor: pointer;
   width: 100%;
   color: #1a1a2e;
   font-size: 11px;
   font-weight: 700;
   transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.1s;
   text-align: left;
}
.slide-action-btn:hover {
   background: #6C1C19;
   border-color: #6C1C19;
   color: #FFFFFF;
   transform: scale(1.03);
}
.slide-action-btn ::v-deep .v-icon {
   color: inherit !important;
   transition: color 0.2s;
}

/* ── Grid de campos ── */
.slide-grid {
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 5px 10px;
   flex: 1;
}
.slide-grid--4col { grid-template-columns: repeat(4, 1fr); }
.slide-grid--5col { grid-template-columns: repeat(5, 1fr); }

.slide-field {
   display: flex;
   flex-direction: column;
   background: #fff;
   border-radius: 6px;
   padding: 4px 8px;
   box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
.slide-field.sf-wide { grid-column: span 2; }

.sf-label {
   font-size: 11px;
   font-weight: 700;
   text-transform: uppercase;
   letter-spacing: 0.6px;
   color: #A00402;
   line-height: 1.2;
}
.sf-val {
   font-size: 18px;
   font-weight: 500;
   color: #1a1a1a;
   margin-top: 2px;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

/* ── Separador ── */
.slide-divider {
   height: 2px;
   background: linear-gradient(to right, #A00402, transparent);
   border-radius: 2px;
   flex-shrink: 0;
}

/* ── Comentario ── */
.slide-comment {
   background: #fff8e1;
   border-left: 4px solid #deab2f;
   border-radius: 0 8px 8px 0;
   padding: 8px 14px;
   font-size: 13px;
   color: #333;
   flex-shrink: 0;
}

/* ── Tabla slide ── */
.slide-table {
   width: 100%;
   border-collapse: collapse;
   font-size: 14px;
   background: #fff;
   border-radius: 10px;
   overflow: hidden;
   box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}
.slide-table thead tr { background: #A00402; }
.slide-table thead th {
   color: #fff;
   font-weight: 600;
   font-size: 12px;
   text-transform: uppercase;
   letter-spacing: 0.6px;
   padding: 10px 14px;
   text-align: left;
}
.slide-table tbody tr:nth-child(even) { background: #fafafa; }
.slide-table tbody tr:hover { background: #fff3f3; }
.slide-table tbody td {
   padding: 9px 14px;
   color: #2c2c2c;
   border-bottom: 1px solid #eee;
}
.slide-table tfoot td {
   padding: 9px 14px;
   background: #f9f9f9;
   border-top: 2px solid #ddd;
}
.slide-table--compact thead th,
.slide-table--compact tbody td,
.slide-table--compact tfoot td { padding: 7px 10px; font-size: 13px; }
.slide-empty-row { text-align: center; color: #999; font-style: italic; padding: 20px !important; }
.td-clamp {
   display: -webkit-box;
   -webkit-line-clamp: 1;
   -webkit-box-orient: vertical;
   overflow: hidden;
   cursor: pointer;
   transition: color 0.15s;
}
.td-clamp:hover { color: #A00402; }

/* ── Layout 2 columnas ── */
.slide-body--2col {
   flex-direction: row !important;
   gap: 16px;
}
.slide-card {
   flex: 1;
   background: #fff;
   border-radius: 10px;
   padding: 16px;
   box-shadow: 0 1px 4px rgba(0,0,0,0.1);
   display: flex;
   flex-direction: column;
   gap: 8px;
   overflow: hidden;
}
.slide-card-title {
   font-size: 15px;
   font-weight: 700;
   color: #333;
   padding-bottom: 8px;
   border-bottom: 2px solid #A00402;
   display: flex;
   align-items: center;
}

/* ── Ensayo ── */
.slide-body--essay { flex-direction: column; }
.slide-essay {
   flex: 1;
   font-size: 28px;
   line-height: 1.75;
   color: #2c2c2c;
   background: #fff;
   border-radius: 10px;
   padding: 20px 28px;
   box-shadow: 0 1px 4px rgba(0,0,0,0.1);
   text-align: justify;
   white-space: pre-wrap;
}

/* ── Burbuja mini (dentro de tablas) ── */
.comp-burbuja-mini {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 28px;
   height: 28px;
   border-radius: 50%;
   background: #A00402;
   cursor: pointer;
   transition: transform 0.18s cubic-bezier(.34,1.56,.64,1), box-shadow 0.18s;
   box-shadow: 0 2px 6px rgba(160,4,2,0.35);
}
.comp-burbuja-mini:hover {
   transform: scale(1.25);
   box-shadow: 0 4px 12px rgba(160,4,2,0.5);
}

/* ══ COMPROBANTES ══ */
.slide-body--comprobantes {
   position: relative;
   overflow: hidden;
}
.comprobante-grid {
   flex: 1;
   display: flex;
   flex-wrap: wrap;
   gap: 20px;
   padding: 20px;
   justify-content: space-evenly;
   align-content: space-evenly;
   overflow: hidden;
}
.comprobante-burbuja {
   position: relative;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   width: 160px;
   height: 160px;
   border-radius: 50%;
   background: #fff;
   box-shadow: 0 4px 16px rgba(0,0,0,0.13);
   cursor: pointer;
   transition: transform 0.22s cubic-bezier(.34,1.56,.64,1), box-shadow 0.2s;
   padding: 12px;
   text-align: center;
   border: 2px solid #e0e0e0;
}
.comprobante-burbuja:hover {
   transform: scale(1.12);
   box-shadow: 0 8px 28px rgba(160,4,2,0.22);
   border-color: #A00402;
}
.burbuja--validado {
   border-color: #2e7d32;
   background: #f1f8f1;
}
.burbuja-icono { margin-bottom: 8px; }
.burbuja-nombre {
   font-size: 13px;
   font-weight: 600;
   color: #333;
   line-height: 1.3;
   overflow: hidden;
   display: -webkit-box;
   -webkit-line-clamp: 3;
   -webkit-box-orient: vertical;
}
.burbuja-check {
   position: absolute;
   top: 6px;
   right: 8px;
}

/* ── Visor zoom ── */
.visor-overlay {
   position: fixed;
   inset: 0;
   background: rgba(0,0,0,0.72);
   display: flex;
   align-items: center;
   justify-content: center;
   z-index: 10000;
}
.visor-card {
   width: 88%;
   height: 90%;
   background: #1a1a1a;
   border-radius: 12px;
   display: flex;
   flex-direction: column;
   overflow: hidden;
   box-shadow: 0 20px 60px rgba(0,0,0,0.6);
}
.visor-header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 10px 18px;
   background: #A00402;
   color: #fff;
   flex-shrink: 0;
}
.visor-titulo {
   font-size: 15px;
   font-weight: 700;
}
.visor-body {
   flex: 1;
   display: flex;
   align-items: center;
   justify-content: center;
   overflow: hidden;
   background: #111;
}
.visor-img {
   max-width: 100%;
   max-height: 100%;
   object-fit: contain;
}
.visor-iframe {
   width: 100%;
   height: 100%;
   border: none;
}

/* Transición visor */
.visor-fade-enter-active,
.visor-fade-leave-active { transition: opacity 0.2s, transform 0.25s; }
.visor-fade-enter, .visor-fade-leave-to { opacity: 0; transform: scale(0.88); }

/* ── Fila vista en dialog solicitudes ── */
::v-deep .fila-vista td { background: #f0f7f0 !important; }
::v-deep .fila-vista:hover td { background: #e0f0e0 !important; }

/* ── Toast de feedback en modo presentación ── */
.slide-toast {
   position: fixed;
   bottom: 72px;
   right: 24px;
   z-index: 10500;
   display: flex;
   align-items: center;
   padding: 10px 18px;
   border-radius: 8px;
   color: #fff;
   font-size: 13px;
   font-weight: 500;
   box-shadow: 0 4px 14px rgba(0,0,0,0.25);
   pointer-events: none;
}
.slide-toast--success { background: #2e7d32; }
.slide-toast--error   { background: #c62828; }

.slide-toast-enter-active, .slide-toast-leave-active { transition: opacity 0.25s, transform 0.25s; }
.slide-toast-enter, .slide-toast-leave-to            { opacity: 0; transform: translateY(12px); }

</style>
